﻿import Chartist from 'chartist';
import $ from 'jquery';

window.$ = window.jQuery = $;

var token = '';
var refreshTimer = 0;
var refreshTime = 0;

$.ajaxSetup({
	xhrFields: {
		withCredentials: true,
	},
});

function getRequestUrl(endpoint) {
	return `/api/admin/${endpoint}`;
}

var d_2d = new Date(new Date().getTime() - 172800000);
var d_5d = new Date(new Date().getTime() - 432000000);
var recentBookId =
	d_2d.getYear() +
	1900 +
	(d_2d.getMonth() < 9 ? '0' : '') +
	(d_2d.getMonth() + 1);
var d_5ddate =
	d_5d.getYear() +
	1900 +
	'-' +
	(d_5d.getMonth() < 9 ? '0' : '') +
	(d_5d.getMonth() + 1) +
	'-' +
	(d_5d.getDate() <= 9 ? '0' : '') +
	d_5d.getDate();
var d_tm = new Date(new Date().getTime() + 86400000);
var d_tmts =
	d_tm.getYear() +
	1900 +
	'-' +
	(d_tm.getMonth() < 9 ? '0' : '') +
	(d_tm.getMonth() + 1) +
	'-' +
	(d_tm.getDate() <= 9 ? '0' : '') +
	d_tm.getDate() +
	' ' +
	(d_tm.getHours() <= 9 ? '0' : '') +
	d_tm.getHours() +
	':00';
let possibleRights = [];
let possibleRightsTranslation = {
	silentmonitor: 'You can listen to talents',
	voicefile: 'Manage voice files',
	calendar: 'Manage Calendar',
	invoice: 'View invoices',
	stats: 'Statistics (sales shown)',
	statslimited: 'Statistics (sales hidden)',
	report: '',
	message: 'Write messages to agents',
	adminpm: 'Give rights to other users',
	call: 'Call agents',
	jobinvite: 'invite Agents to projects',
	owner: 'Change user settings, e.g. profile picture, address, documents',
	workforce: 'Complete talent management/contracts',
	curelations: 'Edit outbound lists/browse inbound calls',
	modulemanage: 'Create and manage modules',
	bonuspay: 'Pay out bonus',
	invoicenow: '',
	dailylogintoken: '',
	mapping: 'Create/manage mappings',
};
let rightsUpdated = false;

var config = [
	{ title: 'Listen' } /* ================================== */,
	{
		title: 'Customer list',
		options: [
			{
				name: 'active',
				type: 'checkbox',
				default: true,
				title: 'Nur \u00FCber Einzahlschwelle',
			},
			{ name: 'email', type: 'text', default: '', title: 'E-Mail (**)' },
			{ name: 'name', type: 'text', default: '', title: 'Firma, Kontakt (**)' },
			{
				name: 'country',
				type: 'text',
				default: '',
				title: 'Land (K\u00FCrzel*)',
			},
			{
				name: 'geopos',
				type: 'text',
				default: '',
				title: 'Umkreissuche Mittelpunkt (***)',
			},
			{
				name: 'verifystate',
				type: 'enum',
				default: '',
				title: 'E-Mail verifiziert',
				values: { Y: 'ja', N: 'nein', '': 'egal' },
			},
			{
				name: 'profilepic',
				type: 'enum',
				default: '',
				title: 'Profilbild',
				values: { Y: 'ja', N: 'nein', '': 'egal' },
			},
			{
				name: 'sort',
				type: 'enum',
				default: '',
				title: 'Sortierung',
				values: {
					idd: 'Id \u25BC',
					emaila: 'E-Mail \u25B2',
					emaild: 'E-Mail \u25BC',
					companya: 'Firmenname \u25B2',
					companyd: 'Firmenname \u25BC',
				},
			},
			{
				type: 'comment',
				text: '* K\u00FCrzel k\u00F6nnen mit ! negiert werden. z.B. Land=!DE',
			},
			{
				type: 'comment',
				text: '** Platzhalter: _ ein Zeichen, % beliebig viele Zeichen; z.B. E-Mail=kunden%yoummday.com',
			},
			{
				type: 'comment',
				text: '*** Namen (Yoummday Southafrica), Adressen (Marktstr 17, 80802 München, Deutschland) oder Koordinaten (48.1633, 11.5879); Sortiert wird nach Entfernung',
			},
		],
		request: function (opts) {
			api('listuser', {
				usertype: 'cu',
				active: opts.active,
				geopos: opts.geopos,
				name: opts.name,
				email: opts.email,
				country: opts.country,
				verifystate: opts.verifystate,
				profilepic: opts.profilepic,
				sort: opts.sort,
				limit: 2000,
			});
		},
	},
	{
		title: 'Agentenliste',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'Kunden-Id' },
			{
				name: 'active',
				type: 'checkbox',
				default: true,
				title: 'Nur in den letzten 48h Aktive',
			},
			{ name: 'email', type: 'text', default: '', title: 'E-Mail (**)' },
			{ name: 'name', type: 'text', default: '', title: 'Name (**)' },
			{
				name: 'country',
				type: 'text',
				default: '',
				title: 'Land (K\u00FCrzel*)',
			},
			{
				name: 'lang',
				type: 'text',
				default: '',
				title: 'Sprache (K\u00FCrzel*)',
			},
			{
				name: 'skill',
				type: 'text',
				default: '',
				title: 'Fachbereich (K\u00FCrzel*)',
			},
			{
				name: 'expBusiness',
				type: 'text',
				default: '',
				title: 'Branche (K\u00FCrzel*)',
			},
			{
				name: 'geopos',
				type: 'text',
				default: '',
				title: 'Umkreissuche Mittelpunkt (***)',
			},
			{
				name: 'blockstate',
				type: 'enum',
				default: 'N',
				title: 'Gesperrt',
				values: { Y: 'ja', N: 'nein', '': 'egal' },
			},
			{
				name: 'onboarded',
				type: 'enum',
				default: '',
				title: 'Geonboarded',
				values: { Y: 'ja', N: 'nein', '': 'egal' },
			},
			{
				name: 'verifystate',
				type: 'enum',
				default: 'Y',
				title: 'E-Mail verifiziert',
				values: { Y: 'ja', N: 'nein', '': 'egal' },
			},
			{
				name: 'voicesample',
				type: 'enum',
				default: '',
				title: 'Tonaufnahme',
				values: { Y: 'ja', N: 'nein', '': 'egal' },
			},
			{
				name: 'profilepic',
				type: 'enum',
				default: '',
				title: 'Profilbild',
				values: { Y: 'ja', N: 'nein', '': 'egal' },
			},
			{
				name: 'sort',
				type: 'enum',
				default: '',
				title: 'Sortierung',
				values: {
					idd: 'Id \u25BC',
					emaila: 'E-Mail \u25B2',
					emaild: 'E-Mail \u25BC',
					namea: 'Name \u25B2',
					named: 'Name \u25BC',
				},
			},
			{
				type: 'comment',
				text: '* K\u00FCrzel k\u00F6nnen mit ! negiert werden. z.B. Land=!DE',
			},
			{
				type: 'comment',
				text: '** Platzhalter: _ ein Zeichen, % beliebig viele Zeichen; z.B. Name=Josef%',
			},
			{
				type: 'comment',
				text: '*** Namen (Yoummday Southafrica), Adressen (Marktstr 17, 80802 München, Deutschland) oder Koordinaten (48.1633, 11.5879); Sortiert wird nach Entfernung',
			},
		],
		request: function (opts) {
			api('listuser', {
				userid: opts.userid,
				usertype: 'sp',
				active: opts.active,
				geopos: opts.geopos,
				name: opts.name,
				email: opts.email,
				country: opts.country,
				lang: opts.lang,
				skill: opts.skill,
				expBusiness: opts.expBusiness,
				onboarded: opts.onboarded,
				blockstate: opts.blockstate,
				verifystate: opts.verifystate,
				voicesample: opts.voicesample,
				profilepic: opts.profilepic,
				sort: opts.sort,
				limit: 2000,
			});
		},
	},
	{
		title: 'Vertr\u00e4ge',
		options: [
			{
				name: 'userid',
				type: 'text',
				default: '',
				title: 'Agent/Kunde (Id/E-Mail)',
			},
			{ name: 'active', type: 'checkbox', default: true, title: 'Nur aktive' },
		],
		request: function (opts) {
			if (opts.userid)
				api('contracts', {
					userid: opts.userid,
					active: opts.active,
					limit: 5000,
				});
		},
	},
	{
		title: 'Dokumente',
		options: [
			{
				name: 'userid',
				type: 'text',
				default: '',
				title: 'Agent/Kunde (Id/E-Mail)',
			},
		],
		request: function (opts) {
			if (opts.userid) api('admdocument', { userId: opts.userid });
		},
	},
	{
		title: 'Frage des Tages',
		options: [
			{ name: 'date', type: 'text', default: '', title: 'Datum (YYYY-MM-DD)' },
			{ name: 'question', type: 'text', default: '', title: 'Frage' },
			{ name: 'answer1', type: 'text', title: 'Antwort 1' },
			{ name: 'answer2', type: 'text', title: 'Antwort 2' },
			{ name: 'answer3', type: 'text', title: 'Antwort 3' },
			{ name: 'answer4', type: 'text', title: 'Antwort 4' },
			{ name: 'answer5', type: 'text', title: 'Antwort 5' },
		],
		request: function (opts) {
			api('dailysurvey', {
				date: opts.date,
				question: opts.question,
				answer1: opts.answer1,
				answer2: opts.answer2,
				answer3: opts.answer3,
				answer4: opts.answer4,
				answer5: opts.answer5,
			});
		},
	},
	{
		title: 'SIP/VPN Logs',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'Agent (Id/E-Mail)' },
		],
		request: function (opts) {
			if (opts.userid) api('siplog', { userid: opts.userid });
		},
	},
	{
		title: 'Betriebs\u00FCberwachung',
	} /* ================================== */,
	{
		title: 'Agenten im Gespr\u00e4ch',
		options: [],
		request: function (opts) {
			api('agentcalls', { cmd: 'agentcalls' });
		},
	},
	{
		title: 'Agenten Minuten',
		deprecated: 1,
		options: [
			{
				type: 'comment',
				text: 'Es wird ein Zeitraum von 30 Tagen ausgewertet wenn ein Kunde ausgewählt wurde, sonst 7 Tage.',
			},
			{ name: 'userid', type: 'text', default: '', title: 'Kunden-Id' },
		],
		request: function (opts) {
			api('agentminutes', { userid: opts.userid, limit: 1000 });
		},
	},
	{
		title: 'Anrufstatistik IB',
		deprecated: 1,
		options: [
			{
				name: 'userid',
				type: 'text',
				default: '',
				title: 'Kunden-Id oder E-Mail',
			},
			{
				name: 'from',
				type: 'text',
				default: d_5ddate.substr(0, 10) + ' 00:00:00',
				title: 'Start (UTC)',
			},
			{
				name: 'to',
				type: 'text',
				default: '2038-01-01 00:00:00',
				title: 'Ende (UTC)',
			},
			{
				name: 'mode',
				type: 'enum',
				default: 'day',
				title: 'Modus',
				values: { day: 'Tag', hour: 'Stunde' },
			},
			{ type: 'comment', text: 'Max. 3 Monate in die Vergangenheit' },
		],
		request: function (opts) {
			if (!opts.userid) return;
			api(
				'inboundcallstats',
				{
					userid: opts.userid,
					from: opts.from,
					to: opts.to,
					mode: opts.mode,
				},
				opts.mode,
			);
		},
	},
	{
		title: 'Warteschlange',
		options: [],
		request: function (opts) {
			api('fifo', {});
		},
	},
	{
		title: 'Zugang zum Bericht',
		options: [
			{ name: 'userId', type: 'text', default: '', title: 'User-ID' },
			{ name: 'report', type: 'text', default: '', title: 'Bericht' },
			{
				name: 'action',
				type: 'enum',
				default: 'S',
				title: 'Aktion',
				values: { S: 'setzen', D: 'l\u00f6schen' },
			},
		],
		request: function (opts) {
			api('accesstoreport', {
				userId: opts.userId,
				report: opts.report,
				delete: opts.action == 'D' ? 1 : 0,
			});
		},
	},
	{ title: 'Verwaltung' } /* ================================== */,
	{
		title: 'Module',
		options: [
			{
				name: 'userid',
				type: 'text',
				default: '',
				title: 'Nutzer-Id / E-Mail Kunde',
			},
			{
				type: 'comment',
				color: 'red',
				text: 'Achtung: Ab hier nur Einstellungen vornehmen, wenn genau klar ist, was passiert.',
			},
			{ name: 'module', type: 'text', default: '', title: 'Modulk\u00FCrzel' },

			{
				name: 'askRecordingComplete',
				type: 'enum',
				default: '',
				title: 'Aufzeichnung Gespr\u00E4ch',
				values: {
					'': 'unver\u00E4ndert',
					optin: 'Opt-In',
					optout: 'Opt-Out',
					'-': 'nein',
				},
			},
			{
				name: 'askRecordingStartStop',
				type: 'enum',
				default: '',
				title: 'Vertrags-Mitschnitt',
				values: { '': 'unver\u00E4ndert', 1: 'ja', 0: 'nein' },
			},

			{
				name: 'minutePrice1',
				type: 'enum',
				default: '',
				title: 'Minutenpreis',
				values: { '': 'unver\u00E4ndert', var: 'verhandelbar', fix: 'fest' },
			},
			{
				name: 'minutePrice2',
				type: 'text',
				default: '0.00',
				title: 'fester Minutenpreis',
			},
			{
				name: 'billingIncrement',
				type: 'enum',
				default: '',
				title: 'Taktung',
				values: {
					'': 'unver\u00E4ndert',
					1: '1s',
					10: '10s',
					30: '30s',
					60: '1min',
					120: '2min',
					180: '3min',
				},
			},
			{
				name: 'maxBillSeconds',
				type: 'enum',
				default: '',
				title: 'max. bezahlte Zeit',
				values: {
					'': 'unver\u00E4ndert',
					60: '1min',
					120: '2min',
					180: '3min',
					240: '4min',
					300: '5min',
					600: '10min',
					900: '15min',
					1200: '20min',
					1800: '30min',
					0: 'unbegrenzt',
				},
			},
			{
				name: 'workminute',
				type: 'enum',
				default: '',
				title: 'Bearbeitungsminute',
				values: {
					'': 'unver\u00E4ndert',
					0: 'nein',
					1: 'einfach',
					2: 'doppelt',
					3: 'dreifach',
				},
			},
		],
		request: function (opts) {
			var minutePrice = opts.minutePrice1;
			if (minutePrice == 'var') {
				minutePrice = '-';
			} else if (minutePrice == 'fix') {
				minutePrice = opts.minutePrice2.replace(/,/, '.').trim();
				if (minutePrice.match(/[^0-9.]/)) minutePrice = '';
			} else {
				minutePrice = '';
			}

			if (opts.userid.length) {
				if (opts.module.length) {
					api('modules', {
						userid: opts.userid,
						module: opts.module,
						askRecordingComplete: opts.askRecordingComplete,
						askRecordingStartStop: opts.askRecordingStartStop,
						minutePrice: minutePrice,
						billingIncrement: opts.billingIncrement,
						maxBillSeconds: opts.maxBillSeconds,
						workminute: opts.workminute,
					});
				} else {
					api('modules', { userid: opts.userid });
				}
			}
		},
	},
	{
		title: 'Postpaid Dispo',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'Kunden-Id' },
			{ name: 'amount', type: 'text', default: '', title: 'Betrag' },
			{
				name: 'unlimited',
				type: 'checkbox',
				default: '',
				title: 'unlimitiert',
				onchange: function (x, y) {
					$('#optamount').attr(
						'disabled',
						$('#optunlimited:checked').length != 0,
					);
				},
			},
		],
		btnTitle: 'Dispo setzen',
		request: function (opts) {
			opts.amount *= 1;
			opts.amount = opts.amount.toFixed(2);
			if (opts.unlimited) opts.amount = 99999999.99;
			if (opts.userid.length && opts.amount != '' && !isNaN(opts.amount)) {
				if (opts.amount < 0) opts.amount = 0;
				if (opts.amount > 99999999) opts.amount = 99999999.99;
				var a = opts.amount;
				if (a == 99999999.99) a = 'UNLIMITIERT';
				var c = confirm(
					'Wirklich den Dispo des Kunden ' +
						opts.userid +
						' auf ' +
						a +
						' setzen?',
				);
				if (!c) opts.amount = '';
			}
			api('dispo', { userid: opts.userid, amount: opts.amount });
		},
	},
	{
		title: 'Nutzer l\u00f6schen',
		options: [
			{ name: 'userid', type: 'text', title: 'Nutzer-Id' },
			{
				name: 'email',
				type: 'text',
				default: '',
				title: 'E-Mail zur Best\u00e4tigung',
			},
			{
				name: 'state',
				type: 'enum',
				default: '',
				title: 'Aktion',
				values: { L: 'sperren', U: 'entsperren', D: 'l\u00f6schen' },
			},
			{
				name: 'note',
				type: 'text',
				default: '',
				title: 'Grund / Kommentar (Pflichtfeld)',
			},
		],
		btnTitle: 'Ausf\u00fchren',
		request: function (opts) {
			let note = opts.note.replace(/^\s+|\s+$/g, '');
			if (opts.userid && opts.state && note !== '')
				api('blockuser', {
					userid: opts.userid,
					email: opts.email,
					state: opts.state,
					note: note,
				});
		},
	},
	/*	Raus Mitte Maerz 2021 - wer beschwert sich?
        {
            "title": "Silentmonitor",
            "options": [
                {"name":"userX", "type":"text", "default": "", "title":"Nutzer-Id / E-Mail Berechtigter"},
                {"name":"userCu", "type":"text", "default": "", "title":"Nutzer-Id / E-Mail Kunde des Telefonats"},
                {"name":"userSp", "type":"text", "default": "", "title":"Nutzer-Id / E-Mail Agent des Telefonats"},
                {"name":"validTo", "type":"text", "default": d_tmts, "title":"G\u00FCltig bis (UTC!, YYYY-MM-DD hh:mm)"},
            ],
            "request": function(opts) {
                api("silentmonitor", {"auth":auth, "userid":opts.userX, "userSp":opts.userSp, "userCu":opts.userCu, "validTo":opts.validTo });
            }
        },
    */
	{
		code: 'manage_rights',
		title: 'Manage Rights',
		options: [
			{
				name: 'userPm',
				type: 'text',
				default: '',
				optional: 1,
				title: 'User-ID pm/sp',
			},
			{
				name: 'userCu',
				type: 'text',
				default: '',
				optional: 1,
				title: 'User ID cu',
			},
			{
				name: 'action',
				type: 'enum',
				default: 'list',
				title: 'Action',
				values: { list: 'List', set: 'Set rights', delete: 'Delete rights' },
			},
			// Rights chackkbox moved to init get all values from DB
		],
		request: function (opts) {
			var rights = [];
			for (var a in opts) {
				if (a.startsWith('rights_') && opts[a] != 0) {
					rights.push(a.slice(7));
				}
			}
			rights = rights.join(',');
			if (opts.userPm || opts.userCu)
				if (opts.userPm && opts.userCu) {
					api('dashboard', {
						userPm: opts.userPm,
						userCu: opts.userCu,
						action: opts.action,
						rights: rights,
					});
				} else if (opts.userCu && !opts.userPm) {
					api('dashboard', {
						userCu: opts.userCu,
						action: opts.action,
						rights: rights,
					});
				} else if (opts.userPm && !opts.userCu) {
					api('dashboard', {
						userPm: opts.userPm,
						action: opts.action,
						rights: rights,
					});
				}
		},
	},
	{
		title: 'Roaming Users',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'User-Id' },
			{
				name: 'canroamuntil',
				type: 'text',
				default: '',
				placeholder: 'yyyy-mm-dd',
				title: 'Prüfung aussetzen bis',
			},
		],
		btnTitle: 'Ausnahme setzen',
		request: function (opts) {
			if (opts.userid.length && opts.canroamuntil.length) {
				var c = confirm(
					'Wirklich die Prüfung des Benutzers ' +
						opts.userid +
						' auf ' +
						opts.canroamuntil +
						' setzen?',
				);
				if (!c) {
					opts.canroamuntil = '';
				}
			}
			api('handleroamingusers', {
				userid: opts.userid,
				canroamuntil: opts.canroamuntil,
			});
		},
	},
	{
		title: 'Werberbonus',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'User-Id' },
			{
				name: 'fromDate',
				type: 'text',
				default: d_tmts.substr(0, 8) + '01',
				placeholder: 'yyyy-mm-dd',
				title: 'Anmeldedatum von (inkl.)',
			},
			{
				name: 'toDate',
				type: 'text',
				default: '2099-01-01',
				placeholder: 'yyyy-mm-dd',
				title: 'Anmeldedatum bis (exkl.)',
			},
			{
				name: 'amountWerUm',
				type: 'text',
				placeholder: '150.00',
				title:
					'Provision f\u00FCr Werber, wenn der Geworbene 500 EUR Umsatz innerhalb von 180 Tagen macht',
			},
			{
				name: 'amountGewUm',
				type: 'text',
				placeholder: '50.00',
				title:
					'Provision f\u00FCr den Geworbenen, wenn er 500 EUR Umsatz innerhalb von 180 Tagen macht',
			},
			{
				type: 'comment',
				color: 'red',
				text: 'Achtung! Nicht voreilig Regeln l\u00f6schen! Es z\u00E4hlt das Anmeldedatum des Geworbenen, die Regeln werden oft erst viel sp\u00E4ter erf\u00Fcllt.',
			},
			{
				name: 'action',
				type: 'enum',
				default: 'S',
				title: 'Aktion',
				values: { S: 'setzen', D: 'l\u00f6schen' },
			},
		],
		request: function (opts) {
			if (opts.userid.length) {
				if (!opts.amountWerUm.length || !opts.amountGewUm.length) {
					alert(
						'Die zwei Werte m\u00FCssen ausgef\u00FCllt werden. Notfalls auch mit 0.',
					);
					return;
				}
			}
			api('referalprovision', {
				userid: opts.userid,
				fromDate: opts.fromDate,
				toDate: opts.toDate,
				amountWerUm: opts.amountWerUm,
				amountGewUm: opts.amountGewUm,
				delete: opts.action == 'D' ? 1 : 0,
			});
		},
	},
	{
		title: 'Onboarding-Rechte',
		options: [
			{ name: 'onboardingUserId', type: 'text', default: '', title: 'User-Id' },
			{
				name: 'onboarding',
				type: 'enum',
				default: '',
				title: 'Onboarding',
				values: { y: 'ja', n: 'nein' },
			},
			{
				name: 'onboardingReadonly',
				type: 'enum',
				default: '',
				title: 'Onboarding read-only',
				values: { y: 'ja', n: 'nein' },
			},
		],
		request: function (opts) {
			$('#optonboardingUserId').focus(() => {
				$(
					'#optonboarding0,#optonboarding1,#optonboardingReadonly0,#optonboardingReadonly1',
				).prop('checked', false);
			});
			$('#optonboarding0').click(() => {
				$('#optonboarding1,#optonboardingReadonly0').prop('checked', false);
				$('#optonboardingReadonly1').prop('checked', true);
			});
			$('#optonboardingReadonly0').click(() => {
				$('#optonboarding0,#optonboardingReadonly1').prop('checked', false);
				$('#optonboarding1').prop('checked', true);
			});
			api('onboardingfeatures', {
				userid: opts.onboardingUserId,
				onboarding: opts.onboarding,
				onboardingReadonly: opts.onboardingReadonly,
			});
		},
	},
	{
		title: 'Kunden Nummer Verwaltung',
	} /* ================================== */,
	{
		title: 'Verifizierte Nummern Liste',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'UserCu-Id' },
		],
		request: function (opts) {
			api('verifiednumberlist', { userid: opts.userid });
		},
	},
	{
		title: 'Nummer Verifizieren',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'UserCu-Id' },
			{ name: 'phone', type: 'text', default: '', title: 'Nummer' },
			{
				name: 'confirm',
				type: 'checkbox',
				default: '',
				title: 'Bestätigen, dass du dir sicher bist',
			},
		],
		request: function (opts) {
			api('verifynumber', {
				userid: opts.userid,
				phone: opts.phone,
				confirm: opts.confirm,
			});
		},
	},
	{
		title: 'Nummer Löschen',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'UserCu-Id' },
			{ name: 'phone', type: 'text', default: '', title: 'Nummer' },
			{
				name: 'confirm',
				type: 'checkbox',
				default: '',
				title: 'Bestätigen, dass du dir sicher bist',
			},
		],
		request: function (opts) {
			api('verifiednumberdelete', {
				userid: opts.userid,
				phone: opts.phone,
				confirm: opts.confirm,
			});
		},
	},
	{ title: 'Telefoniekonfig' } /* ================================== */,
	{
		title: 'Telefoniesounds',
		btnTitle: 'Hochladen/Liste Anzeigen',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'User-Id' },
			{ name: 'name', type: 'text', default: '', title: 'Name' },
			{
				name: 'type',
				type: 'enum',
				default: 'fifo_music',
				title: 'Kategorie',
				values: {
					all: 'Alle Kategorien',
					queue: 'Warteschleifenmusik',
					preQueue: 'Ansagen vor Warteschleife',
					outOfOffice: 'Out of office Ansage',
					askRecord: 'Einverständnis für Aufnahme',
					maxTime: 'Rauswurf wegen maximaldauer',
					callerLimit: 'Rauswurf wegen maximaler WS Anzahl',
					callbackOffer: 'Ansage für Rückruf',
					fifoChime: 'Einspieler zwischen Musik',
				},
			},
			{
				name: 'file',
				type: 'file',
				default: '',
				title: 'Datei',
				valuetypes: 'audio/wave,audio/mpeg,.wav,.wave,.mp3',
			},
			{
				type: 'comment',
				text: 'Es kann mehrere Minuten dauern bis die Datei auf den Telefonieservern verteilt, konvertiert und benutzbar ist',
			},
		],
		request: function (opts) {
			if (opts.userid != '') {
				if (opts.file !== '') {
					upload('uploadsound', {
						companyuser: opts.userid,
						type: opts.type,
						name: opts.name,
						file: opts.file,
					});
				} else {
					api('soundlist', {
						companyuser: opts.userid,
					});
				}
			}
		},
	},
	{
		title: 'WS Konfiguration',
		btnTitle: 'Anzeigen/Ändern',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'User-Id' },
			{
				name: 'phone',
				type: 'text',
				default: '',
				title: 'zu verändernde Telefonnummer',
			},
			{ name: 'sndid', type: 'text', title: 'Sound ID' },
			{
				name: 'type',
				type: 'enum',
				default: 'queue',
				title: 'Kategorie',
				values: {
					queue: 'Warteschleifenmusik',
					preQueue: 'Ansagen vor Warteschleife',
					outOfOffice: 'Out of office Ansage',
					askRecord: 'Einverständnis für Aufnahme',
					maxTime: 'Rauswurf wegen maximaldauer',
					callerLimit: 'Rauswurf wegen maximaler WS Anzahl',
					callbackOffer: 'Ansage für Rückruf',
					queueChimeIn: 'Einspieler zwischen Musik',
				},
			},

			{
				type: 'comment',
				text: 'Sound wird jede Minute neu ausgelesen',
			},
		],
		request: function (opts) {
			if (opts.userid != '') {
				if (opts.sndid !== '' && opts.phone !== '') {
					api('setsoundnumber', {
						companyuser: opts.userid,
						phone: opts.phone,
						type: opts.type,
						sndid: opts.sndid,
					});
				} else {
					api('getroutings', {
						companyuser: opts.userid,
					});
				}
			}
		},
	},
	{
		title: 'Tel Server Health',
		btnTitle: 'Anzeigen',
		options: [],
		request: function (opts) {
			api('telhealth');
		},
	},
	{ title: 'Buchhaltung' },
	{
		title: 'Einzelverbindungsnachweis',
		options: [
			{
				name: 'userId',
				type: 'text',
				default: '',
				title: 'Nutzer (Id/E-Mail)',
			},
			{
				name: 'month',
				type: 'text',
				default: recentBookId,
				title: 'Monat (YYYYMM)',
			},
		],
		request: function (opts) {
			if (opts.userId && opts.month)
				api('evn', { userId: opts.userId, month: opts.month, limit: 10000 });
		},
	},
	{
		title: 'Rechnungen',
		options: [
			{ name: 'bookid', type: 'text', default: recentBookId, title: 'YYYYMM' },
		],
		request: function (opts) {
			api('invoice', { bookid: opts.bookid });
		},
	},
	{
		title: 'Auszahlungen',
		options: [
			{
				name: 'format',
				type: 'enum',
				default: '',
				title: 'Modus',
				values: { '': 'Liste', SEPA: 'SEPA', DTA: 'DTA' },
			},
			{
				name: 'ignorehp',
				type: 'checkbox',
				default: '',
				title: 'Zahlungspause ignorieren',
			},
			{
				name: 'fttlMode',
				type: 'checkbox',
				default: '',
				title: 'Fttl Modus (checked = nur fttls, unchecked = keine fttls)',
			},
			{
				type: 'comment',
				text: 'Die Daten sind immer live und \u00E4ndern sich, sobald Auszahlungen im System verbucht sind.',
			},
		],
		request: function (opts) {
			if (opts.format) {
				download('payoutdata', {
					format: opts.format,
					ignoreHoldPayment: opts.ignorehp,
					fttlMode: opts.fttlMode,
				});
			} else {
				api('payoutdata', {
					ignoreHoldPayment: opts.ignorehp,
					fttlMode: opts.fttlMode,
				});
			}
		},
	},
	{
		title: 'Hold Payment setzen',
		options: [
			{ name: 'userid', type: 'text', title: 'Nutzer-Id' },
			{
				name: 'hold',
				type: 'checkbox',
				default: false,
				title: 'Payment Halt forcieren / entfernen',
			},
		],
		btnTitle: 'Ausf\u00fchren',
		request: function (opts) {
			if (opts.userid)
				api('forceholdpayment', { userid: opts.userid, hold: opts.hold });
		},
	},
	{
		title: 'Talent-Zahlungen',
		options: [
			{ name: 'userId', type: 'text', default: '', title: 'Agent/Kunde ID' },
		],
		request: function (opts) {
			if (opts.userId) {
				api('talentbookings', {
					userId: opts.userId,
				});
			}
		},
	},
	{
		title: 'HBCI Zuordnung',
		options: [
			{
				name: 'hbciid',
				type: 'text',
				default: '',
				title: 'HBCI-Id',
			},
			{
				name: 'userid',
				type: 'text',
				default: '',
				title: 'User-Id',
			},
			{
				name: 'discard',
				type: 'checkbox',
				default: false,
				title: 'Zahlung verwerfen',
			},
		],
		request: function (opts) {
			if (opts.userid !== '' && opts.discard) {
				alert('Nicht eindeutig: Verwerfen oder einem Nutzer zuordnen?');
			} else if (opts.hbciid !== '' && opts.discard) {
				api('hbciassign', {
					action: 'discard',
					hbciid: opts.hbciid,
				});
			} else if (opts.hbciid !== '' && opts.userid !== '') {
				api('hbciassign', {
					action: 'assign',
					hbciid: opts.hbciid,
					userid: opts.userid,
				});
			} else {
				api('hbciassign', {
					action: 'list',
					hbciid: opts.hbciid,
				});
			}
		},
	},
	{
		title: 'Extrageb\u00FChren',
		options: [
			{
				name: 'userid',
				type: 'text',
				default: '',
				title: 'Nutzer-Id (zum Anlegen und Filtern)',
			},
			{ name: 'id', type: 'text', title: 'Geb\u00FChren-Id (zum Bearbeiten)' },
			{
				name: 'startDate',
				type: 'text',
				title: 'erste Ausf\u00FChrung YYYY-MM-DD',
			},
			{
				name: 'endDate',
				type: 'text',
				title: 'letzte Ausf\u00FChrung YYYY-MM-DD',
			},
			{
				name: 'descr',
				type: 'text',
				title: 'Beschreibung (kommt auf die Rechnung)',
			},
			{
				name: 'interval',
				type: 'enum',
				title: 'Ausf\u00FChrungsinterval',
				values: {
					daily: 't\u00E4glich',
					weekly: 'w\u00F6chentlich',
					monthly: 'monatlich',
				},
			},
			{ name: 'amount', type: 'text', title: 'Betrag' },
		],
		request: function (opts) {
			api('extrafee', {
				id: opts.id,
				userid: opts.userid,
				startDate: opts.startDate,
				endDate: opts.endDate,
				descr: opts.descr,
				interval: opts.interval,
				amount: opts.amount,
			});
		},
	},
	{ title: 'Ai Qa' } /* ================================== */,
	{
		title: 'Ai Qa Config',
		options: [
			{ name: 'userid', type: 'text', default: '', title: 'User Id' },
			{ name: 'criterias', type: 'text', default: '', title: 'Criteria Ids' },
		],
		request: function (opts) {
			if (opts.userid.length) {
				api('upsertaiqaconfig', {
					userid: opts.userid,
					criterias: opts.criterias,
				});
			}
		},
	},
	{
		title: 'Ai Qa Criteria',
		options: [
			{ name: 'criteriaid', type: 'text', default: '', title: 'Criteria Id' },
			{ name: 'label', type: 'text', default: '', title: 'Label' },
			{ name: 'formtype', type: 'text', default: '', title: 'Form Type' },
			{ name: 'modeltype', type: 'text', default: '', title: 'Model Type' },
			{ name: 'details', type: 'text', default: '', title: 'Details' },
		],
		request: function (opts) {
			if (opts.userid.length) {
				api('upsertaiqacriteria', {
					criteriaid: opts.criteriaid,
					label: opts.label,
					type: opts.type,
					formtype: opts.formtype,
					modeltype: opts.modeltype,
					details: opts.details,
				});
			}
		},
	},
];

function startRefresh() {
	if (refreshTimer) clearTimeout(refreshTimer);
	refreshTimer = 0;
	if (refreshTime <= 0) {
		api('agentcalls');
	} else {
		$('#refresh').text('Neuladen in ' + refreshTime + '...');
		refreshTime--;
		refreshTimer = setTimeout(startRefresh, 1000);
	}
}

function exportToExcel() {
	var title = 'test';
	var $table = $('#result').clone();
	$table
		.find('td.select,th.select,BUTTON,IMG,INPUT,AUDIO,SPAN[class=circle]')
		.remove();
	$table.find('A').removeAttr('href');
	$table.find('*').removeAttr('class');
	var table = $table.html();

	var html =
		'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">' +
		'<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><!--[if gte mso 9]><xml>' +
		'<x:ExcelWorkbook>' +
		'<x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
		title +
		'</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>' +
		'</x:ExcelWorksheets>' +
		'</x:ExcelWorkbook></xml><![endif]--></head>' +
		'<body>' +
		table +
		'</body></html>';

	html = html.replace(/[^\x20-x7f]/g, function (x) {
		return '&#' + x.charCodeAt(0) + ';';
	});
	//html = unescape(encodeURIComponent(html));	// utf8 bytes

	var uri =
		'data:application/vnd.ms-excel;base64,' +
		window.btoa('\xEF\xBB\xBF' + html);
	var $a = $('<A>');
	$a.attr('href', uri);
	$a.attr('download', 'export.xls');
	$a.append('Excel');
	$('BODY').append($a);
	$a[0].click();
	$a.remove();
}

function download(path, data) {
	var $f = $('<FORM>')
		.attr('method', 'post')
		.attr('action', getRequestUrl(path))
		.attr('target', '_blank')
		.css({ display: 'none' });
	for (var k in data) {
		var $i = $('<INPUT>').attr('name', k).attr('value', data[k]);
		$f.append($i);
	}
	$('BODY').append($f);
	$f.submit();
}

function redirectFromResponseHeader(request) {
	if (!request || !request.getResponseHeader) return false;

	var redirectTo =
		request.getResponseHeader('x-rediretct-to') ||
		request.getResponseHeader('x-redirect-to');
	if (!redirectTo) return false;

	window.location.assign(redirectTo);
	return true;
}

function upload(path, data) {
	let fd = new FormData();
	for (const [key, value] of Object.entries(data)) {
		fd.append(key, value);
	}
	$('#block').css('opacity', '0').show().animate({ opacity: '0.5' }, 1000);
	$.ajax({
		// Your server script to process the upload
		url: getRequestUrl(path),
		type: 'POST',

		// Form data
		data: fd,

		// so that we have the auth cookie
		xhrFields: {
			withCredentials: true,
		},

		// Tell jQuery not to process data or worry about content-type
		// You *must* include these options!
		cache: false,
		contentType: false,
		processData: false,
		dataType: 'json',
		// Custom XMLHttpRequest
		success: function (result, status, request) {
			$('#block').finish().hide();
			if (redirectFromResponseHeader(request)) return;

			if (result.error) {
				alert(result.error);
			} else if (!result.success) {
				alert('Fehler');
			} else {
				showResult(path, data, result);
			}
		},
	});
}

function logout() {
	api('../logout');
}

function api(path, data, ref) {
	if (refreshTimer) clearTimeout(refreshTimer);
	refreshTimer = 0;
	if (!data) data = {};
	data['token'] = token;

	$('#block').css('opacity', '0').show().animate({ opacity: '0.5' }, 1000);
	$.post(getRequestUrl(path), data, function (result, status, request) {
		if (redirectFromResponseHeader(request)) {
			$('#block').finish().hide();
			return;
		}

		if (result.error) {
			alert(result.error);
		} else if (!result.success) {
			alert('Fehler');
		} else if (path == 'setcalllost') {
			refreshTime = 0;
			startRefresh();
		} else {
			showResult(path, data, result, ref);
		}
		$('#block').finish().hide();
	}).fail(function (jqXHR, textStatus, errorThrown) {
		$('#block').finish().hide();
		if (redirectFromResponseHeader(jqXHR)) return;

		$('#result *').remove();
		alert('Ups!\n' + errorThrown);
	});
}

function showAgentcalls(result) {
	$('#result *').remove();
	var calls = result.calls;
	var qualNum = result.qualityByNumber;
	var $table = $('<table>');
	var $tr = $('<tr>');
	var $btn;
	var $r;
	var $d;
	var $t;
	var $td;
	$tr.append($('<th>').text(''));
	$tr.append($('<th>').text('Nutzer-Id'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Kunde'));
	$tr.append($('<th>').text('Typ'));
	$tr.append($('<th>').text('Dauer'));
	$tr.append($('<th>').text('SBC UUID'));
	$tr.append($('<th>').text('Tel Host'));
	$tr.append($('<th>').text('Tel Host UUID'));
	$tr.append($('<td>'));
	$table.append($tr);

	var lfdnr = 0;
	var callByType = { Inbound: 0, Outbound: 0 };
	var callByCustomer = {};
	for (var i in calls) {
		var call = calls[i];
		var $tr = $('<tr>');
		var dur =
			Math.floor(call.duration / 60) +
			':' +
			(call.duration % 60 < 10 ? '0' : '') +
			(call.duration % 60);
		var companyName = call.company ? call.company : call.contactName;
		$tr.append($('<td>').text(++lfdnr));
		$tr.append($('<td>').text(call.userId));
		$tr.append($('<td>').text(call.name));
		$tr.append($('<td>').text(companyName));
		$tr.append($('<td>').text(call.action));
		$tr.append($('<td class="r">').text(dur));
		$tr.append($('<td style="letter-spacing: -1px">').text(call.telCallId));
		$tr.append($('<td>').text(call.telHost));
		$tr.append($('<td style="letter-spacing: -1px">').text(call.telId));
		if (call.duration > 300) {
			$btn = $('<button>').text('ignorieren');
			$btn.data('telId', call.telId).click(function () {
				var telId = $(this).data('telId');
				if (confirm('Sicher ?')) {
					api('setcalllost', { telid: telId });
				}
			});
			$tr.append($('<td>').append($btn));
		} else {
			$tr.append($('<td>'));
		}
		$table.append($tr);
		callByType[call.action] = callByType[call.action]
			? callByType[call.action] + 1
			: 1;
		callByCustomer[companyName] = callByCustomer[companyName]
			? callByCustomer[companyName] + 1
			: 1;
	}

	$r = $('<DIV>').attr('id', 'refresh');
	$('#result').append($r);
	refreshTime = 10;
	startRefresh();

	$d = $('<DIV>').css({ float: 'right', margin: 'auto' });

	$t = $('<TABLE>');
	$tr = $('<TR>');
	$td = $('<TD>').css({ 'font-size': '40px' });
	$tr.append($td);
	$td.text(lfdnr);
	$td = $('<TD>').css({ 'font-size': '16px' });
	for (var a in callByType) {
		$td.append($('<SPAN>').text(callByType[a] + ' ' + a));
		$td.append($('<BR>'));
	}
	$tr.append($td);
	$t.append($tr);
	$('#result').append($t);
	$d.append($t);

	$d.append($('<br>'));
	if (Object.keys(callByCustomer).length) $d.append($('<span>').text('Kunden'));

	$t = $('<TABLE>');
	$tr = $('<TR>');
	$td = $('<TD>').css({ 'font-size': '16px' });
	for (var a in callByCustomer) {
		$td.append(
			$('<B>').text(callByCustomer[a]).css({
				width: '30px',
				'text-align': 'right',
				display: 'inline-block',
			}),
		);
		$td.append($('<SPAN>').text(a).css({ 'margin-left': '10px' }));
		$td.append($('<BR>'));
	}
	$tr.append($td);
	$t.append($tr);
	$d.append($t);

	$d.append($('<br>'));
	if (Object.keys(qualNum).length)
		$d.append($('<span>').text('Sprachqualit\u00E4t'));

	$t = $('<TABLE>');
	for (var bnd in qualNum) {
		var first = 1;
		for (var n in qualNum[bnd]) {
			var q = qualNum[bnd][n];
			var a =
				(q.A.cnt > 4 ? (q.A.qual / q.A.cnt).toFixed(1) : '---') +
				' (' +
				q.A.cnt +
				')';
			var b =
				(q.B.cnt > 4 ? (q.B.qual / q.B.cnt).toFixed(1) : '---') +
				' (' +
				q.B.cnt +
				')';
			var aw = q.A.cnt > 4 && q.A.qual < 96 * (q.A.cnt - 1);
			var bw = q.B.cnt > 4 && q.B.qual < 96 * (q.B.cnt - 1);
			$tr = $('<TR>');
			if (first-- > 0) {
				$tr.append(
					$('<TD>')
						.text(bnd)
						.attr('rowspan', Object.keys(qualNum[bnd]).length * 2),
				);
			}
			$tr.append($('<TD>').text(n).attr('rowspan', 2));
			$tr.append(
				$('<TD>')
					.text('A: ' + a)
					.css('color', aw ? '#f77' : '#000'),
			);
			$t.append($tr);
			$tr = $('<TR>');
			$tr.append(
				$('<TD>')
					.text('B: ' + b)
					.css('color', bw ? '#f77' : '#000'),
			);
			$t.append($tr);
		}
	}
	$d.append($t);

	$('#result').append($d);
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showContracts(result) {
	$('#result *').remove();
	var contracts = result.contracts;
	var $table = $('<table>');
	var $tr = $('<tr>');
	$tr.append($('<th>').text('Vertrags-Id'));
	$tr.append($('<th>').text('Start'));
	$tr.append($('<th>').text('Kunde Id'));
	$tr.append($('<th>').text('Kunde Name'));
	$tr.append($('<th>').text('Agent Id'));
	$tr.append($('<th>').text('Agent Name'));
	$tr.append($('<th>').text('Aktiv durch'));
	$tr.append($('<th>').text('Preis'));
	$tr.append($('<th>').text('Favorit'));
	$tr.append($('<th>').text('End'));
	$table.append($tr);

	for (var i in contracts) {
		var contract = contracts[i];
		var $tr = $('<tr>');
		$tr.append($('<td>').text(contract.id));
		$tr.append($('<td>').text(contract.begin));
		$tr.append($('<td>').text(contract.cuId));
		$tr.append($('<td>').text(contract.cuName));
		$tr.append($('<td>').text(contract.spId));
		$tr.append($('<td>').text(contract.spName));
		$tr.append(
			$('<td>').text(
				(contract.activeCu ? 'Kunde' : '') +
					' ' +
					(contract.activeSp ? 'Agent' : ''),
			),
		);
		$tr.append(
			$('<td>').text(
				contract.price.toFixed(2).replace(/\./, ',') + ' ' + '\u20ac/min',
			),
		);
		$tr.append($('<td>').text(contract.favorite ? 'Ja' : ''));
		$tr.append($('<td>').text(contract.endTS));
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showInboundcallstats(result, ref) {
	$('#result *').remove();
	var $d = $('<div>');
	$d.append(
		'Bei Kunden mit Warteschlange kann das Ergebnis abweichen, da nur verarbeitete Anrufe ausgewertet werden.',
	);
	$('#result').append($d);
	var $table = $('<table>');
	var stats = result.stats;
	var $tr = $('<tr>');
	$tr.append($('<th>').text('Time'));
	$tr.append($('<th>').text('Calls'));
	$tr.append($('<th>').text('Contacted'));
	$tr.append($('<th>').text('Abandoned'));
	$tr.append($('<th>').text('Short'));
	$tr.append($('<th>').text('Contacted %'));
	$tr.append($('<th>').text('Avg. Talk Time'));
	$table.append($tr);

	for (var i in stats) {
		var stat = stats[i];
		var $tr = $('<tr>');

		var conper = stat.calls
			? ((100.0 * stat.contacted) / stat.calls).toFixed(2)
			: '-';
		var talktime =
			stat.calls > stat.short
				? (stat.time / (stat.contacted - stat.short)).toFixed(1)
				: -1;

		$tr.append($('<td>').text(i + (ref == 'hour' ? ':xx' : '')));
		$tr.append($('<td>').text(stat.calls));
		$tr.append($('<td>').text(stat.contacted));
		$tr.append($('<td>').text(stat.abandoned));
		$tr.append($('<td>').text(stat.short));
		$tr.append($('<td>').text(conper.replace(/\./, ',')));
		$tr.append($('<td>').text(talktime.replace(/\./, ',')));
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showFifo(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var chann = result.channels;
	var fifos = result.fifos;
	var shift12h = result.shift12h;
	var maxX = result.maxX;
	var minX = result.minX - 60; // 10min
	if (minX < 0) minX = 0;

	var $tab1 = $('<table>').attr('id', 'legend1').append($('<style>'));
	var $tr = $('<tr>');
	$tr.append($('<th>').text(''));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Richtung'));
	$tr.append($('<th>').text('Maximum'));
	$tr.append($('<th>').text('60min Mittel'));
	$tab1.append($tr);
	$tr.click(function () {
		var s = '';
		$('#legend1')
			.find('tr')
			.each(function (i, e) {
				var k = $(e).data('chkey');
				if (k) {
					var d = $(this).data('disabled') ? 0 : 1;
					$(this).data('disabled', d);
					if ($(e).data('disabled')) {
						s += '.legend1 .ct-series-' + k + ' {opacity:0.05} ';
						s += '#legend1 .ct-bg-' + k + ' {opacity:0.15} ';
					}
				}
			});
		$('#legend1 style').text(s);
	});

	var $tab2 = $('<table>').attr('id', 'legend2').append($('<style>'));
	var $tr = $('<tr>');
	$tr.append($('<th>').text(''));
	$tr.append($('<th>').text('Id'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Nummer'));
	$tr.append($('<th>').text('max. Anrufer'));
	$tr.append($('<th>').text('max. Wartezeit'));
	$tab2.append($tr);

	$('#result').append($('<h2>').text('Kan\u00E4le'));
	var $d = $('<div>').attr('id', 'fifochart_channels').addClass('legend1');
	$('#result').append($d);
	$('#result').append($tab1);

	$('#result').append($('<h2>').text('Anrufer'));
	var $d = $('<div>').attr('id', 'fifochart_caller').addClass('legend2');
	$('#result').append($d);
	$('#result').append($('<h2>').text('Wartezeit'));
	var $d = $('<div>').attr('id', 'fifochart_wait').addClass('legend2');
	$('#result').append($d);
	$('#result').append($tab2);

	var x = [];
	for (var i = minX; i <= maxX; i++) {
		x.push(
			i % 360 == 0
				? '|' + ((Math.floor(i / 360) + (shift12h ? 12 : 0)) % 24) + ':00'
				: null,
		);
	}

	var channels = [];
	for (var f = 0; f < chann.length; f++) {
		channels[f] = [];
		for (var i = minX; i <= maxX; i++) {
			channels[f].push(chann[f].count[i] ? chann[f].count[i] : 0);
		}
		var $tr = $('<tr>');
		$tr.data('chkey', f < 15 ? String.fromCharCode(97 + f) : '');
		$tr.append(
			$('<td>')
				.attr('class', f < 15 ? 'ct-bg-' + String.fromCharCode(97 + f) : '')
				.css({ width: '20px' }),
		);
		$tr.append($('<td>').text(chann[f].name));
		$tr.append($('<td>').text(chann[f].direction));
		$tr.append($('<td>').text(chann[f].maxCount));
		$tr.append($('<td>').text(chann[f].avg1h));
		if (f < 15)
			$tr.addClass('clickable').click(function () {
				var d = $(this).data('disabled') ? 0 : 1;
				$(this).data('disabled', d);
				var s = '';
				$('#legend1')
					.find('tr')
					.each(function (i, e) {
						var k = $(e).data('chkey');
						if (k && $(e).data('disabled')) {
							s += '.legend1 .ct-series-' + k + ' {opacity:0.05} ';
							s += '#legend1 .ct-bg-' + k + ' {opacity:0.15} ';
						}
					});
				$('#legend1 style').text(s);
			});
		$tab1.append($tr);
	}

	for (var f = 0; f < fifos.length; f++) {
		var $tr = $('<tr>');
		$tr.data('chkey', f < 15 ? String.fromCharCode(97 + f) : '');
		$tr.append(
			$('<td>')
				.attr('class', f < 15 ? 'ct-bg-' + String.fromCharCode(97 + f) : '')
				.css({ width: '20px' }),
		);
		$tr.append($('<td>').text(fifos[f].userId));
		$tr.append($('<td>').text(fifos[f].userName));
		$tr.append($('<td>').text('+' + fifos[f].number));
		$tr.append($('<td>').text(fifos[f].callerMax));
		$tr.append($('<td>').text(fifos[f].waitMax + 's'));
		if (f < 15)
			$tr.addClass('clickable').click(function () {
				var d = $(this).data('disabled') ? 0 : 1;
				$(this).data('disabled', d);
				var s = '';
				$('#legend2')
					.find('tr')
					.each(function (i, e) {
						var k = $(e).data('chkey');
						if (k && $(e).data('disabled')) {
							s += '.legend2 .ct-series-' + k + ' {opacity:0.05} ';
							s += '#legend2 .ct-bg-' + k + ' {opacity:0.15} ';
						}
					});
				$('#legend2 style').text(s);
			});
		$tab2.append($tr);
	}

	var caller = [];
	var wait = [];
	for (var f = 0; f < fifos.length; f++) {
		caller[f] = [];
		wait[f] = [];
	}
	for (var i = minX; i <= maxX; i++) {
		for (var f = 0; f < fifos.length; f++) {
			caller[f].push(fifos[f].caller[i] ? fifos[f].caller[i] : 0);
			wait[f].push(fifos[f].wait[i] ? fifos[f].wait[i] : 0);
		}
	}

	new Chartist.Line(
		'#fifochart_channels',
		{
			labels: x,
			series: channels,
		},
		{
			fullWidth: true,
			showPoint: false,
			axisX: { showGrid: false },
			axisY: { onlyInteger: true },
			height: '200px',
		},
	);
	new Chartist.Line(
		'#fifochart_caller',
		{
			labels: x,
			series: caller,
		},
		{
			fullWidth: true,
			showPoint: false,
			axisX: { showGrid: false },
			axisY: { onlyInteger: true },
			height: '200px',
		},
	);
	new Chartist.Line(
		'#fifochart_wait',
		{
			labels: x,
			series: wait,
		},
		{
			fullWidth: true,
			showPoint: false,
			axisX: { showGrid: false },
			height: '300px',
		},
	);
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showModules(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var $d = $('<div>');
	$d.append($('<b>').text('Name: ')).append(result.username).append($('<br>'));
	$d.append($('<br>'));
	$('#result').append($d);

	var modules = result.modules;
	var $tr = $('<tr>');
	$tr.append($('<th>').text('Modulk\u00FCrzel'));
	$tr.append($('<th>').text('Typ'));
	$tr.append($('<th>').text('Titel'));
	$tr.append($('<th>').text('Beschreibung'));
	$tr.append($('<th>').text('Nummer'));
	$tr.append($('<th>').text('Preis'));
	$tr.append($('<th>').text('Bearbeitungsminute'));
	$tr.append($('<th>').text('Taktung'));
	$tr.append($('<th>').text('max. bezahlte Zeit'));
	$tr.append($('<th>').text('Aufzeichung Gespr\u00E4ch'));
	$tr.append($('<th>').text('Vertrags-Mitschnitt'));
	$table.append($tr);

	for (var i in modules) {
		var mod = modules[i];
		var type = mod.type.substr(0, 1).toUpperCase() + mod.type.substr(1);
		var descr = mod.description ? '' + mod.description : '';

		var askRecordingComplete = mod.askRecordingComplete;
		if (mod.askRecordingComplete == 'optin') askRecordingComplete = 'Opt-In';
		if (mod.askRecordingComplete == 'optout') askRecordingComplete = 'Opt-Out';
		if (mod.askRecordingComplete == '') askRecordingComplete = 'nein';

		var $tr = $('<tr>');
		$tr.append($('<td>').text(mod.mnemonic));
		$tr.append($('<td>').text(type));
		$tr.append($('<td>').text(mod.title));
		$tr.append(
			$('<td>').text(descr.substr(0, 50) + (descr.length > 50 ? '...' : '')),
		);
		$tr.append($('<td>').text(mod.number));
		$tr.append(
			$('<td>').text(
				mod.minutePrice != null
					? ('' + mod.minutePrice).replace(/\./, ',') +
							' \u20ac' +
							(mod.type == 'inbound' || mod.type == 'outbound' ? '/min' : '')
					: 'verhandelbar',
			),
		);
		$tr.append(
			$('<td>').text(
				mod.workMinute
					? mod.workMinute == 1
						? 'einfach'
						: mod.workMinute + 'x'
					: 'nein',
			),
		);
		$tr.append($('<td>').text(mod.billingIncrement + 's'));
		$tr.append(
			$('<td>').text(
				mod.maxBillSeconds ? mod.maxBillSeconds + 's' : 'unbegrenzt',
			),
		);
		$tr.append($('<td>').text(askRecordingComplete));
		$tr.append($('<td>').text(mod.askRecordingStartStop ? 'ja' : 'nein'));

		$tr
			.addClass('clickable')
			.data('mnemonic', mod.mnemonic)
			.click(function () {
				var mnemonic = $(this).data('mnemonic');
				$('#optmodule').val(mnemonic);
			});
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showFuturepayments(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var payments = result.payments;
	var $tr = $('<tr>');
	$tr.append($('<th>').text('Datum'));
	$tr.append($('<th>').text('Kunde'));
	$tr.append($('<th>').text('Agent'));
	$tr.append($('<th>').text('Zweck'));
	$tr.append($('<th>').text('Netto Kunde'));
	$tr.append($('<th>').text('Netto Agent'));
	$tr.append($('<th>').text('Minuten 30 Tage'));
	$tr.append($('<th>').text('Anrufe 30 Tage'));
	$tr.append($('<th>'));
	$table.append($tr);

	for (var i in payments) {
		var pay = payments[i];

		var $tr = $('<tr>');
		$tr.append($('<td>').text(pay.date));
		$tr.append($('<td>').text(pay.userCu));
		$tr.append($('<td>').text(pay.userSp));
		$tr.append($('<td>').text(pay.purpose));
		$tr.append(
			$('<td>').text(('' + pay.amountCu).replace(/\./, ',') + ' \u20AC'),
		);
		$tr.append(
			$('<td>').text(('' + pay.amountSp).replace(/\./, ',') + ' \u20AC'),
		);
		$tr.append($('<td>').text(pay.minutes));
		$tr.append($('<td>').text(pay.calls));

		var $btn = $('<button>').text('stornieren');
		$btn.data('payid', pay.id).click(function () {
			var payid = $(this).data('payid');
			if (confirm('Sicher ?')) {
				api('futurepayments', { stornopaymentid: payid });
			}
		});
		$tr.append($('<td>').append($btn));

		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showDispo(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var balances = result.balance;
	var $tr = $('<tr>');
	$tr.append($('<th>').text('Id (ext)'));
	$tr.append($('<th>').text('Kunde'));
	$tr.append($('<th>').text('Dispo'));
	$tr.append($('<th>').text('Kontostand'));
	$tr.append($('<th>').text('Letzte Zahlung am'));
	$tr.append($('<th>').text('Letzte Zahlung Betrag'));
	$table.append($tr);

	for (var i in balances) {
		var bal = balances[i];
		if (bal.paymentdate == '0000-00-00') {
			bal.paymentdate = '';
		}
		var $tr = $('<tr>');
		$tr.append($('<td>').text(bal.id));
		$tr.append($('<td>').text(bal.name));
		$tr.append(
			$('<td>')
				.addClass('r')
				.text(
					bal.credit > 99999999
						? 'unlimitiert'
						: bal.credit.toFixed(2).replace(/\./, ',') + ' \u20ac',
				),
		);
		var td = $('<td>')
			.addClass('r')
			.text(
				bal.balance > 99999999
					? 'unlimitiert'
					: bal.balance.toFixed(2).replace(/\./, ',') + ' \u20ac',
			);
		$tr.append(td);
		if (bal.balance < 0.25 * bal.credit) td.css('color', 'red');
		$tr.append($('<td>').text(bal.paymentdate));
		$tr.append(
			$('<td>')
				.addClass('r')
				.text(bal.paymentamount.toFixed(2).replace(/\./, ',') + ' \u20ac'),
		);

		$tr
			.addClass('clickable')
			.data('bal', bal)
			.click(function () {
				bal = $(this).data('bal');
				$('#optuserid').val(bal.id);
				$('#optamount').val(bal.credit > 99999999 ? '' : bal.credit.toFixed(2));
				$('#optunlimited')
					.prop('checked', bal.credit > 99999999)
					.change();
			});

		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showUtilization(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var utilization = result.utilization;
	var dates = result.dates;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Nutzer-Id'));
	$tr.append($('<th>').text('Name'));
	for (var i in dates) $tr.append($('<th>').text(dates[i]));
	$table.append($tr);

	for (var i in utilization) {
		var util = utilization[i];
		var $tr = $('<TR>');
		$tr.append($('<td>').text(util.extid));
		$tr.append($('<td>').text(util.name));
		for (var d in dates) {
			var u = util[dates[d]];

			if (!u) u = {};
			var o = u['online'] ? u['online'] : 0;
			var t = u['tel'] ? u['tel'] : 0;
			var p = u['pay'] ? u['pay'] : 0;
			if (o > 0) {
				if (t > 0) {
					$tr.append(
						$('<td>').text(
							Math.round((100.0 * t) / o, 1) +
								'% ' +
								Math.round((100.0 * p) / o, 1) +
								'%',
						),
					);
				} else {
					$tr.append(
						$('<td>')
							.text(o + ' min')
							.css({ color: '#888' }),
					);
				}
			} else {
				$tr.append($('<td>'));
			}
		}
		$table.append($tr);
	}
	$('#result').append(
		$('<SPAN>').text(
			'Erste Zahl: Telefonierte Zeit; Zweite Zahl: Abgerechnete Zeit',
		),
	);
	$('#result').append($('<BR>'));
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showInvoice(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var invoices = result.invoices;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Datum'));
	$tr.append($('<th>').text('Nutzer'));
	$tr.append($('<th>').text('Land'));
	$tr.append($('<th>').text('Rechnungsnummer'));
	$tr.append($('<th>').text('Empf\u00E4nger'));
	$table.append($tr);

	for (var i in invoices) {
		var iv = invoices[i];
		var ut = iv.userTo;
		var $tr = $('<tr>');
		var type = '???';
		if (ut && ut.type == 'cu') type = 'Kunde';
		if (ut && ut.type == 'sp') type = 'Agent';
		$tr.append($('<td>').text(iv.date));
		$tr.append(
			$('<td>').text(
				ut
					? ut.name
						? ut.name
						: ut.company
							? ut.company
							: ut.contactName
					: '',
			),
		);
		$tr.append($('<td>').text(ut ? ut.country : ''));
		$tr.append($('<td>').text(iv.invoicenumber));
		$tr.append($('<td>').text(type));

		$tr
			.addClass('clickable')
			.data('ivn', iv.invoicenumber)
			.click(function () {
				var ivn = $(this).data('ivn');
				var form = $('<FORM>')
					.attr('method', 'POST')
					.attr('action', getRequestUrl('invoice'));
				form.append(
					$('<INPUT>')
						.attr('type', 'hidden')
						.attr('name', 'invoicenumber')
						.attr('value', ivn),
				);
				form.append($('<INPUT>').attr('type', 'submit'));
				$('BODY').append(form);
				form.submit();
				form.remove();
			});

		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a).append(' ');

		var bookId = $('#optbookid').val();
		$('#result')
			.append(getInvoiceDownloadFor('Kunden PDFs', bookId, 'cu'))
			.append(' ');
		$('#result').append(getInvoiceDownloadFor('Talente PDFs', bookId, 'sp'));
	}

	$('#result').show();
}

function showExtrafee(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var fees = result.fees;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Id'));
	$tr.append($('<th>').text('Nutzer'));
	$tr.append($('<th>').text('erste Ausf\u00FChrung'));
	$tr.append($('<th>').text('letzte Ausf\u00FChrung'));
	$tr.append($('<th>').text('zuletzt berechnet'));
	$tr.append($('<th>').text('n\u00E4chste Ausf\u00FChrung'));
	$tr.append($('<th>').text('Interval'));
	$tr.append($('<th>').text('Betrag'));
	$tr.append($('<th>').text('Beschreibung'));
	$table.append($tr);

	for (var i in fees) {
		var fee = fees[i];
		var user = fee.user;
		var $tr = $('<tr>');
		var interv = '?';
		if (fee.execInterv == 'daily') interv = 't\u00E4glich';
		if (fee.execInterv == 'weekly') interv = 'w\u00F6chentlich';
		if (fee.execInterv == 'monthly') interv = 'monatlich';
		$tr.append($('<td>').text(fee.id));
		$tr.append(
			$('<td>').text(
				user.company
					? user.company
					: user.contactName
						? user.contactName
						: user.name,
			),
		);
		$tr.append($('<td>').text(fee.startDate));
		$tr.append($('<td>').text(fee.endDate));
		$tr.append($('<td>').text(fee.lastRun));
		$tr.append($('<td>').text(fee.nextRun));
		$tr.append($('<td>').text(interv));
		$tr.append(
			$('<td>').text(fee.amount.toFixed(2).replace(/\./, ',') + ' \u20ac'),
		);
		$tr.append($('<td>').text(fee.descr));

		$tr
			.addClass('clickable')
			.data('fee', fee)
			.click(function () {
				var fee = $(this).data('fee');
				$('#optid').val(fee.id);
				$('#optuserid').val(fee.user.id);
				$('#optstartDate').val(fee.startDate);
				$('#optendDate').val(fee.endDate);
				$('#optamount').val(fee.amount.toFixed(2));
				$('#optdescr').val(fee.descr);
				$('#option input[name=optinterval][value=' + fee.execInterv + ']').prop(
					'checked',
					true,
				);
			});

		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showPayoutdata(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var sums = result.sums;
	var payouts = result.payouts;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Status'));
	$tr.append($('<th>').text('Anzahl'));
	$tr.append($('<th>').text('Summe'));
	$table.append($tr);

	for (var i in sums) {
		var sum = sums[i];
		var $tr = $('<tr>');
		$tr.append($('<td>').text(sum.state));
		$tr.append($('<td>').text(sum.cnt));
		$tr.append(
			$('<td>')
				.text(sum.sum.toFixed(2).replace(/\./, ',') + ' \u20ac')
				.addClass('r'),
		);
		$table.append($tr);
	}

	$('#result').append($table).append($('<BR>'));
	var $tableSEPA = $('<table>');
	var $tableDTA = $('<table>');
	var $table = $('<table>');

	$('#result').append($('<H2>').text('SEPA'));
	$('#result').append($tableSEPA).append($('<BR>'));
	$('#result').append($('<H2>').text('DTA'));
	$('#result').append($tableDTA).append($('<BR>'));
	$('#result').append($('<H2>').text('Fehler'));

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('SWIFT'));
	$tr.append($('<th>').text('IBAN'));
	$tr.append($('<th>').text('Zweck'));
	$tr.append($('<th>').text('Betrag'));
	$tableSEPA.append($tr.clone());

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Nummer'));
	$tr.append($('<th>').text('Branch'));
	$tr.append($('<th>').text('SWIFT'));
	$tr.append($('<th>').text('IBAN'));
	$tr.append($('<th>').text('Zweck'));
	$tr.append($('<th>').text('Betrag'));
	$tableDTA.append($tr.clone());

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Status'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Nummer'));
	$tr.append($('<th>').text('Branch'));
	$tr.append($('<th>').text('SWIFT'));
	$tr.append($('<th>').text('IBAN'));
	$tr.append($('<th>').text('Zweck'));
	$tr.append($('<th>').text('Betrag'));
	$table.append($tr);

	for (var i in payouts) {
		var po = payouts[i];
		var $tr = $('<tr>');
		var amount = po.amount.toFixed(2).replace(/\./, ',') + ' \u20ac';

		if (po.state == 'SEPA') {
			$tr.append($('<td>').text(po.name));
			$tr.append(
				$('<td>').text(po.swift + ' ' + po.bankAccNum + ' ' + po.bankBranchId),
			);
			$tr.append($('<td>').text(po.iban));
			$tr.append($('<td>').text(po.text));
			$tr.append($('<td>').text(amount).addClass('r'));
			$tableSEPA.append($tr);
		} else if (po.state == 'DTA') {
			$tr.append($('<td>').text(po.name));
			$tr.append($('<td>').text(po.bankAccNum));
			$tr.append($('<td>').text(po.bankBranchId));
			$tr.append($('<td>').text(po.swift));
			$tr.append($('<td>').text(po.iban));
			$tr.append($('<td>').text(po.text));
			$tr.append($('<td>').text(amount).addClass('r'));
			$tableDTA.append($tr);
		} else {
			$tr.append($('<td>').text(po.state));
			$tr.append($('<td>').text(po.name));
			$tr.append($('<td>').text(po.bankAccNum));
			$tr.append($('<td>').text(po.bankBranchId));
			$tr.append($('<td>').text(po.swift));
			$tr.append($('<td>').text(po.iban));
			$tr.append($('<td>').text(po.text));
			$tr.append($('<td>').text(amount).addClass('r'));
			$table.append($tr);
		}
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 0) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showSilentmonitor(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var permissions = result.permissions;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Berechtigter').attr('colspan', 2));
	$tr.append($('<th>').text('Kunde').attr('colspan', 2));
	$tr.append($('<th>').text('Agent').attr('colspan', 2));
	$tr.append($('<th>').text(''));
	$table.append($tr);

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Id'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Id'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Id'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('G\u00FCltig bis'));
	$table.append($tr);

	for (var i in permissions) {
		var sm = permissions[i];
		var $tr = $('<tr>');
		$tr.append($('<td>').text(sm.user.id));
		$tr.append($('<td>').text(sm.user.name));
		$tr.append(
			$('<td>').text(sm.wildcardCu ? '-' : sm.userCu ? sm.userCu.id : '?'),
		);
		$tr.append(
			$('<td>').text(sm.wildcardCu ? '-' : sm.userCu ? sm.userCu.name : '?'),
		);
		$tr.append(
			$('<td>').text(sm.wildcardSp ? '-' : sm.userSp ? sm.userSp.id : '?'),
		);
		$tr.append(
			$('<td>').text(sm.wildcardSp ? '-' : sm.userSp ? sm.userSp.name : '?'),
		);
		$tr.append($('<td>').text(sm.validTo));
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showDashboard(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var list = result.list;

	var css = { transform: 'rotate(-60deg', width: '70px' };
	var $tr = $('<tr>');
	$tr.append($('<th>').text('PM Id'));
	$tr.append($('<th>').text('PM Name'));
	$tr.append($('<th>').text('User Id'));
	$tr.append($('<th>').text('User Name'));
	for (var right of possibleRights) {
		$tr.append($('<th>').append($('<span>').css(css).text(right)));
	}
	$table.append($tr);

	for (var i in list) {
		var l = list[i];
		var $tr = $('<tr>');
		$tr.append($('<td>').text(l.userPm.id));
		$tr.append($('<td>').text(l.userPm.name));
		$tr.append($('<td>').text(l.userCu.id));
		$tr.append($('<td>').text(l.userCu.name));
		for (var right of possibleRights) {
			$tr.append($('<td>').text(l.rights.indexOf(right) == -1 ? ' ' : 'X'));
		}

		$tr
			.addClass('clickable')
			.data('pm', l.userPm.id)
			.data('cu', l.userCu.id)
			.data('ri', l.rights)
			.click(function () {
				var pm = $(this).data('pm');
				var cu = $(this).data('cu');
				var rights = $(this).data('ri');
				$('#optuserPm').val(pm);
				$('#optuserCu').val(cu);
				for (var right of possibleRights) {
					$('#optrights_' + right).prop('checked', rights.indexOf(right) != -1);
				}
			});

		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showEvn(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var payments = result.payments;
	var user = result.user;

	var txt = '';
	if (result.limitreached) {
		txt =
			'Das Abfragelimit wurde erreicht, es werden nur ' +
			payments.length +
			' Zeilen angezeigt.';
	} else {
		txt = 'Es wurden <b>' + payments.length + '</b> Zeilen gefunden.';
	}
	if (result.limitreached) txt += '';

	$('#result').append($('<SPAN>' + txt + '</SPAN>'));

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Zeit'));
	$tr.append($('<th>').text('Typ'));
	$tr.append($('<th>').text('Brutto'));
	$tr.append($('<th>').text('Netto'));
	$tr.append($('<th>').text('Minuten'));
	$table.append($tr);

	var types = {
		payment: 'Zahlung',
		telagent: 'Telefonie',
		telagentplus: 'Telefonie+Bearbeitung',
		telterm: 'Terminierung',
		provision: 'Provision',
		bonuspay: 'Bonuszahlung',
		chat: 'Chat',
	};

	for (var i in payments) {
		var p = payments[i];
		var type = p.type;
		if (typeof types[type] != 'undefined') type = types[type];

		var $tr = $('<tr>');
		$tr.append($('<td>').text(p.createTS));
		$tr.append($('<td>').text(type));
		$tr.append(
			$('<td>')
				.text(p.amount.toFixed(4).replace(/\./, ',') + ' \u20AC')
				.addClass('r'),
		);
		$tr.append(
			$('<td>')
				.text(p.amountNet.toFixed(4).replace(/\./, ',') + ' \u20AC')
				.addClass('r'),
		);
		$tr.append($('<td>').text(p.minutes));
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showDocument(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var docs = result.docs;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Typ'));
	$tr.append($('<th>').text('Zeitpunkt'));
	$tr.append($('<th>').text('Bezeichnung'));
	$tr.append($('<th>').text('Sichtbarkeit'));
	$tr.append($('<th>').text('Link'));
	$table.append($tr);

	for (var i in docs) {
		var d = docs[i];

		var size = Math.round(d.size / 1024);
		var doctype = d.doctype;
		if (doctype == 'unknown') doctype = '';
		var vis = d.visibility;
		var mark = 0;
		if (vis == 'private') {
			vis = 'privat';
			mark = 1;
		}
		if (vis == 'deleted') {
			vis = 'gel\u00F6scht';
			mark = 1;
		}
		if (vis == 'restricted') vis = 'gesch\u00FCtzt';
		if (vis == 'public') vis = '\u00F6ffentlich';

		var $tr = $('<tr>');
		$tr.append($('<td>').text(doctype));
		$tr.append($('<td>').text(d.createTS));
		$tr.append($('<td>').text(d.title));
		$tr.append(
			$('<td>')
				.text(vis)
				.attr('style', mark ? 'color:red' : ''),
		);
		$tr.append(
			$('<td>').append(
				$('<A>')
					.attr('href', d.url)
					.attr('target', '_blank')
					.text(d.ext.toUpperCase() + ' (' + size + 'kB)'),
			),
		);
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showDailysurvey(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var surveys = result.surveys;
	var nextday = result.nextday;
	if ($('#optdate').val() == '' && nextday) $('#optdate').val(nextday);
	$(
		'#optquestion,#optanswer1,#optanswer2,#optanswer3,#optanswer4,#optanswer5',
	).css('width', '400px');

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Datum'));
	$tr.append($('<th>').text('Frage'));
	$tr.append($('<th>').text('Antwort 1'));
	$tr.append($('<th>').text('Antwort 2'));
	$tr.append($('<th>').text('Antwort 3'));
	$tr.append($('<th>').text('Antwort 4'));
	$tr.append($('<th>').text('Antwort 5'));
	$tr.append($('<th>').text('Resultat 1'));
	$tr.append($('<th>').text('Resultat 2'));
	$tr.append($('<th>').text('Resultat 3'));
	$tr.append($('<th>').text('Resultat 4'));
	$tr.append($('<th>').text('Resultat 5'));
	$table.append($tr);

	for (var date in surveys) {
		var s = surveys[date];
		for (var j = 1; j <= 5; j++)
			if (typeof s.answers[j] == 'undefined') s.answers[j] = '';
		if (typeof s.results == 'undefined' || s.results.length == 0)
			s.results = { 1: '', 2: '', 3: '', 4: '', 5: '' };
		for (var j = 1; j <= 5; j++)
			if (typeof s.results[j] == 'undefined')
				s.results[j] = s.answers[j].length ? 0 : '';
		var $tr = $('<tr>');
		$tr.append($('<td>').text(date));
		$tr.append($('<td>').text(s.question));
		$tr.append($('<td>').text(s.answers[1]));
		$tr.append($('<td>').text(s.answers[2]));
		$tr.append($('<td>').text(s.answers[3]));
		$tr.append($('<td>').text(s.answers[4]));
		$tr.append($('<td>').text(s.answers[5]));
		$tr.append($('<td>').text(s.results[1]));
		$tr.append($('<td>').text(s.results[2]));
		$tr.append($('<td>').text(s.results[3]));
		$tr.append($('<td>').text(s.results[4]));
		$tr.append($('<td>').text(s.results[5]));
		$table.append($tr);
		if (s.editable) {
			$tr
				.addClass('clickable')
				.data('date', date)
				.data('question', s.question)
				.data('answers', s.answers)
				.click(function () {
					$('#optdate').val($(this).data('date'));
					$('#optquestion').val($(this).data('question'));
					$('#optanswer1').val($(this).data('answers')[1]);
					$('#optanswer2').val($(this).data('answers')[2]);
					$('#optanswer3').val($(this).data('answers')[3]);
					$('#optanswer4').val($(this).data('answers')[4]);
					$('#optanswer5').val($(this).data('answers')[5]);
				});
		}
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showSiplog(result) {
	$('#result *').remove();
	var $table = $('<table>');
	if (result.user && result.user.name) {
		var $d = $('<div>');
		$d.append($('<b>').text('Name: '))
			.append(result.user.name)
			.append($('<br>'));
		$d.append($('<br>'));
		$('#result').append($d);
	}

	var siplog = result.siplog;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Von (UTC)'));
	$tr.append($('<th>').text('Bis (UTC)'));
	$tr.append($('<th>').text('IP'));
	$tr.append($('<th>').text('Softphone'));
	$tr.append($('<th>').text('Land'));
	$tr.append($('<th>').text('Autonomes System'));
	$tr.append($('<th>').text('Ort Internetzugang (teilweise unscharf)'));
	$table.append($tr);

	for (var i in siplog) {
		var s = siplog[i];
		var $tr = $('<tr>');
		$tr.append($('<td>').text(s.beginTS));
		$tr.append($('<td>').text(s.endTS));
		$tr.append($('<td>').text(s.ext_ip));
		$tr.append($('<td>').text(s.useragent));
		$tr.append($('<td>').text(s.country));
		$tr.append($('<td>').text(s.asn));
		$tr.append($('<td>').text(s.city));
		$table.append($tr);
	}

	if (siplog.length == 0) {
		var $tr = $('<tr>');
		$tr.append(
			$('<td>')
				.text('Keine SIP Aufzeichnungen in letzter Zeit')
				.attr('colspan', 8),
		);
		$table.append($tr);
	}

	$('#result').append($table);
	$('#result').append($('<br><br>'));
	var $table = $('<table>');

	var vpnlog = result.vpnlog;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('Von (UTC)'));
	$tr.append($('<th>').text('Bis (UTC)'));
	$tr.append($('<th>').text('IP'));
	$tr.append($('<th>').text('Zertifikat'));
	$tr.append($('<th>').text('Host'));
	$tr.append($('<th>').text('Traffic'));
	$tr.append($('<th>').text('Land'));
	$tr.append($('<th>').text('Autonomes System'));
	$tr.append($('<th>').text('Ort Internetzugang (teilweise unscharf)'));
	$table.append($tr);

	for (var i in vpnlog) {
		var s = vpnlog[i];
		var $tr = $('<tr>');
		$tr.append($('<td>').text(s.beginTS));
		$tr.append($('<td>').text(s.endTS));
		$tr.append($('<td>').text(s.ext_ip));
		$tr.append($('<td>').text(s.name));
		$tr.append($('<td>').text(s.hostname));
		$tr.append(
			$('<td>').text(
				Math.round(s.recv / 1048576) +
					' MB / ' +
					Math.round(s.sent / 1048576) +
					' MB',
			),
		);
		$tr.append($('<td>').text(s.country));
		$tr.append($('<td>').text(s.asn));
		$tr.append($('<td>').text(s.city));
		$table.append($tr);
	}

	if (vpnlog.length == 0) {
		var $tr = $('<tr>');
		$tr.append(
			$('<td>')
				.text('Keine VPN Aufzeichnungen in letzter Zeit')
				.attr('colspan', 8),
		);
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showConcentrix(result) {
	$('#result *').remove();
	var $table = $('<table>');
	var users = result.users;

	var $tr = $('<tr>');
	$tr.append($('<th>').text('\u2713'));
	$tr.append($('<th>').text('Prio'));
	$tr.append($('<th>').text('Id'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Qualitycheck'));
	$tr.append($('<th>').text('Vertrag'));
	$tr.append($('<th>').text('Adresse'));
	$table.append($tr);

	for (var i in users) {
		var u = users[i];
		var addrCol = '#900';
		var cntrCol = '#900';
		if (u.address == 'home') {
			u.address = '\u2302 home';
			addrCol = '#090';
		}

		if (u.address == 'office') {
			u.address = '\u2338 office';
			addrCol = '#00c';
		}

		if (u.contract == 'valid') {
			u.contract = '\u2713 valid';
			cntrCol = '#090';
		}

		if (u.contract == 'paused by customer') {
			cntrCol = '#00c';
		}

		var $tr = $('<tr>');
		$tr.append($('<td>').text('').addClass('check'));
		$tr.append($('<td>').text(u.prio));
		$tr.append($('<td>').text(u.id));
		$tr.append($('<td>').text(u.name));
		$tr.append($('<td>').text(u.score).css('text-align', 'right'));
		$tr.append($('<td>').text(u.contract).css('color', cntrCol));
		$tr.append($('<td>').text(u.address).css('color', addrCol));

		$tr
			.addClass('clickable')
			.data('id', u.id)
			.click(function () {
				var $c = $(this).find('.check');
				$c.text($c.text().length ? '' : '\u2713');

				var ids = '';
				$('#result table tr').each(function (i, e) {
					if ($(e).find('.check').text().length) {
						ids += ',' + $(e).data('id');
					}
				});
				$('#optuserids').val(ids.substr(1));
			});

		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showHandleroamingusers(result) {
	$('#result *').remove();
	var $table = $('<table>');
	let users = result.roamingUsers;
	var $tr = $('<tr>');

	if (users.length) {
		$tr.append($('<th>').text('Id (ext)'));
		$tr.append($('<th>').text('Name'));
		$tr.append($('<th>').text('Auffällig seit'));
		$tr.append($('<th>').text('Softlock seit'));
		$tr.append($('<th>').text('Benutzer hat E-Mail gesendet am'));
		$tr.append($('<th>').text('Freigeschaltet bis'));
		$tr.append($('<th>').text('Land'));
		$tr.append($('<th>').text('Login-Länder'));
		$table.append($tr);

		for (var offset in users) {
			let user = users[offset];
			var $tr = $('<tr>');

			$tr.append($('<td>').text(user.id));
			$tr.append($('<td>').text(user.name));
			$tr.append($('<td>').text(user.checkForRoamingTS));
			$tr.append($('<td>').text(user.softlockTS));
			$tr.append($('<td>').text(user.softlockMailSentTS));
			$tr.append($('<td>').text(user.canRoamUntilDate));
			$tr.append($('<td>').text(user.country));
			$tr.append($('<td>').text(user.loginCountries.join(' / ')));

			if (user.isHardlocked) {
				$tr.css({ 'background-color': '#fa8072' });
			}

			$tr
				.addClass('clickable')
				.data('user', user)
				.click(function () {
					let user = $(this).data('user');
					$('#optuserid').val(user.id);
				});

			$table.append($tr);
		}
	} else {
		$tr.append($('<th>').text('Keine auffälligen Benutzer gefunden'));
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showReferalprovision(result) {
	$('#result *').remove();
	var $table = $('<table>');
	let provisions = result.provisions;
	var $tr = $('<tr>');
	$tr.append($('<th>').text('Id (ext)'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Von'));
	$tr.append($('<th>').text('Bis'));
	$tr.append($('<th>').text('Werber @ Umsatz'));
	$tr.append($('<th>').text('Geworbener @ Umsatz'));

	$table.append($tr);

	for (var p in provisions) {
		let user = provisions[p].user;
		let provs = provisions[p].provs;
		var first = 1;
		for (var q in provs) {
			let prov = provs[q];
			var $tr = $('<tr>');
			$tr.append($('<td>').text(first ? user.id : ''));
			$tr.append($('<td>').text(first ? user.name : ''));
			$tr.append($('<td>').text(prov.fromDate));
			$tr.append($('<td>').text(prov.toDate));
			$tr.append(
				$('<td>')
					.text(prov.amountWerUm + ' EUR')
					.addClass('r'),
			);
			$tr.append(
				$('<td>')
					.text(prov.amountGewUm + ' EUR')
					.addClass('r'),
			);
			$tr
				.addClass('clickable')
				.data('userid', user.id)
				.data('fromDate', prov.fromDate)
				.data('toDate', prov.toDate)
				.data('amountWerUm', prov.amountWerUm)
				.data('amountGewUm', prov.amountGewUm)
				.click(function () {
					$('#optuserid').val($(this).data('userid'));
					$('#optfromDate').val($(this).data('fromDate'));
					$('#opttoDate').val($(this).data('toDate'));
					$('#optamountWerUm').val($(this).data('amountWerUm'));
					$('#optamountGewUm').val($(this).data('amountGewUm'));
				});
			$table.append($tr);
			first = 0;
		}
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showAccessToReport(result) {
	$('#result *').remove();
	var $table = $('<table>');
	let rights = result.rights;
	var $tr = $('<tr>');
	$tr.append($('<th>').text('User-ID'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Bericht'));
	$table.append($tr);

	for (var r in rights) {
		let user = rights[r].user;
		let reports = rights[r].reports;
		for (var i in reports) {
			let report = reports[i];
			var $tr = $('<tr>');
			$tr.append($('<td>').text(user.id));
			$tr.append($('<td>').text(user.name));
			$tr.append($('<td>').text(report));
			$tr
				.addClass('clickable')
				.data('userId', user.id)
				.data('report', report)
				.click(function () {
					$('#optuserId').val($(this).data('userId'));
					$('#optreport').val($(this).data('report'));
				});
			$table.append($tr);
		}
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showHBCI(result) {
	$('#result *').remove();

	// Todo: add oldHBCI if present
	let suggestions = result.oldHBCI;
	if (Array.isArray(suggestions) && suggestions.length) {
		let $table = $('<table>');
		let hbci = result.oldHBCI;
		let $tr = $('<tr>');
		$tr.append($('<th>').text('User-Id'));
		$tr.append($('<th>').text('Valuta'));
		$tr.append($('<th>').text('BIC'));
		$tr.append($('<th>').text('IBAN'));
		$tr.append($('<th>').text('Name'));
		$tr.append($('<th>').text('Zweck'));
		$tr.append($('<th>').text('Amount'));
		$table.append($tr);
		for (var i in hbci) {
			let h = hbci[i];
			let $tr = $('<tr>');
			$tr.append($('<td>').text(h.userid));
			$tr.append($('<td>').text(h.valuta));
			$tr.append($('<td>').text(h.bic));
			$tr.append($('<td>').text(h.iban));
			$tr.append($('<td>').text(h.name));
			$tr.append($('<td>').text(h.zweck));
			$tr.append(
				$('<td>')
					.text(h.amount + ' EUR')
					.addClass('r'),
			);
			$tr
				.addClass('clickable')
				.data('userid', h.userid)
				.click(function () {
					$('#optuserid').val($(this).data('userid'));
				});
			$table.append($tr);
		}
		$('#result').append(
			$(
				'<SPAN>Vergleichbare Zuordnungen aus den letzten 180 Tagen. Wählen Sie eine Zeile, um die Zuordnung zu übernehmen.</SPAN>',
			),
		);
		$table.css({ opacity: '0.6' });
		$('#result').append($table);
		$('#result').append('<br><br>');
	}

	let $table = $('<table>');
	let hbci = result.badHBCI;
	let $tr = $('<tr>');
	$tr.append($('<th>').text('Id'));
	$tr.append($('<th>').text('Valuta'));
	$tr.append($('<th>').text('Buchung'));
	$tr.append($('<th>').text('BIC'));
	$tr.append($('<th>').text('IBAN'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Zweck'));
	$tr.append($('<th>').text('Amount'));
	$table.append($tr);

	for (var j in hbci) {
		let h = hbci[j];
		let $tr = $('<tr>');
		$tr.append($('<td>').text(h.id));
		$tr.append($('<td>').text(h.valuta));
		$tr.append($('<td>').text(h.buchung));
		$tr.append($('<td>').text(h.bic));
		$tr.append($('<td>').text(h.iban));
		$tr.append($('<td>').text(h.name));
		$tr.append($('<td>').text(h.zweck));
		$tr.append(
			$('<td>')
				.text(h.amount + ' EUR')
				.addClass('r'),
		);
		$tr
			.addClass('clickable')
			.data('hbciid', h.id)
			.click(function () {
				$('#opthbciid').val($(this).data('hbciid'));
				$('#optuserid').val('');
				$('#optdiscard').prop('checked', false);
				updateBtnClicked();
			});
		$table.append($tr);
	}
	$('#result').append($('<SPAN>Nicht zugeordnete Zahlungen.</SPAN>'));
	$('#result').append($table);
	var config = $('#choose button.selected').data('config');
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showTalentbookings(result) {
	$('#result *').remove();

	const $table = $('<table>');
	let $tr = $('<tr>');
	[
		'Typ',
		'Datum & Uhrzeit (UTC)',
		'Zahlungsempfänger',
		'Buchungsmonat',
		'Wert',
		'Args',
	].map((v) => $tr.append($('<th>').text(v)));
	$table.append($tr);

	const keys = ['type', 'createTS', 'coUserId', 'bookid', 'amount', 'jsonArgs'];

	for (let i = 0; i < result.payments.length; i++) {
		let p = result.payments[i];
		$tr = $('<tr>');

		for (let key of keys) {
			let val = p[key];
			if (key === 'jsonArgs') {
				val = Object.entries(val)
					.map(([k, v]) => `${k}=${v}`)
					.join(', ');
			}

			$tr.append($('<td>').text(val));
		}

		$table.append($tr);
	}

	$('#result').append($table);

	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showOnboardingfeatures(result) {
	$('#result *').remove();
	var $table = $('<table>');
	let user = result.user;

	if (typeof user.id !== 'undefined') {
		if (user.onboarding === 1) {
			$('#optonboarding0').prop('checked', true);
			$('#optonboarding1').prop('checked', false);
		} else {
			$('#optonboarding0').prop('checked', false);
			$('#optonboarding1').prop('checked', true);
		}

		if (user.onboardingReadonly === 1) {
			$('#optonboardingReadonly0').prop('checked', true);
			$('#optonboardingReadonly1').prop('checked', false);
		} else {
			$('#optonboardingReadonly0').prop('checked', false);
			$('#optonboardingReadonly1').prop('checked', true);
		}

		let $tr = $('<tr>');
		$tr.append($('<th>').text('Id (ext)'));
		$tr.append($('<th>').text('Name'));
		$tr.append($('<th>').text('Onboarding'));
		$tr.append($('<th>').text('Onboarding read-only'));
		$table.append($tr);

		$tr = $('<tr>');
		$tr.append($('<td>').text(user.id));
		$tr.append($('<td>').text(user.name));
		$tr.append($('<td>').text(user.onboarding === 1 ? 'ja' : 'nein'));
		$tr.append($('<td>').text(user.onboardingReadonly === 1 ? 'ja' : 'nein'));

		$tr
			.addClass('clickable')
			.data('user', user)
			.click(function () {
				let user = $(this).data('user');
				$('#onboardingUserId').val(user.id);
			});

		$table.append($tr);
	} else {
		let $tr = $('<tr>');
		$tr.append($('<th>').text('Kein Benutzer geladen.'));
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showAgentminutes(result) {
	$('#result *').remove();
	var calls = result.calls;
	var $table = $('<table>');
	var $tr = $('<tr>');
	$tr.append($('<th>').text('Nutzer-Id'));
	$tr.append($('<th>').text('Name'));
	$tr.append($('<th>').text('Datum'));
	$tr.append($('<th>').text('Anrufe'));
	$tr.append($('<th>').text('Minuten'));
	$table.append($tr);

	for (var i in calls) {
		var call = calls[i];
		var $tr = $('<tr>');
		$tr.append($('<td>').text(call.userId));
		$tr.append($('<td>').text(call.name));
		$tr.append($('<td>').text(call.date));
		$tr.append($('<td>').text(call.count));
		$tr.append($('<td>').text(call.minutes));
		$table.append($tr);
	}
	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	$('#result').show();
}

function showListUser(data, result) {
	$('#result *').remove();
	var usertype = data.usertype;
	var users = result.users;
	var $tr = $('<tr>');
	var $table = $('<table>');

	var txt = '';
	if (result.limitreached) {
		$('#result').append(
			$('<SPAN>!</SPAN>').css({
				'font-weight': 'bolder',
				color: 'white',
				'margin-right': '2px',
				padding: '0 5px',
				'background-color': 'red',
				'border-radius': '10px 10px 0 0',
			}),
		);
		var txtlr =
			'Das Abfragelimit wurde erreicht, es werden nur ' +
			users.length +
			' Nutzer angezeigt - Bitte die Suche weiter einschr\u00E4nken.';
		$('#result').append($('<SPAN style="color:red">' + txtlr + '</SPAN>'));
	} else {
		txt = 'Es wurden <b>' + users.length + '</b> Nutzer gefunden.';
	}
	if (result.geoaddr) {
		txt +=
			' Es wird im Umkreis um <i>' +
			$('<div/>').text(result.geoaddr).html() +
			'</i> gesucht.';
	}

	$('#result').append($('<SPAN>' + txt + '</SPAN>'));

	if (!result.limitreached) {
		var $checkAll = $('<th>')
			.append($('<input>').attr('type', 'checkbox'))
			.addClass('select');
		$checkAll.click(function () {
			var $t = $(this).closest('table');
			$t.find('th.select input, td.select input').prop(
				'checked',
				$t.find('td.select input').not(':checked').length,
			);
		});
		$tr.append($checkAll);
	}
	$tr.append($('<th>').text('Id (int)'));
	$tr.append($('<th>').text('Id (ext)'));
	if (result.geoaddr) $tr.append($('<th>').text('Entfernung'));
	$tr.append($('<th>').text('Foto'));
	$tr.append($('<th>').text('Registrierung'));
	$tr.append($('<th>').text('E-Mail'));
	$tr.append($('<th>').text('Verifiziert').addClass('small'));
	$tr.append($('<th>').text('E-Mail (YMMD)'));
	$tr.append($('<th>').text('Land'));
	$tr.append($('<th>').text('IP Land'));
	if (usertype == 'cu') {
		$tr.append($('<th>').text('Firma'));
		$tr.append($('<th>').text('Kontakt'));
		$tr.append($('<th>').text('Verwendungszweck'));
		$tr.append($('<th>').text('Postadresse'));
		$tr.append($('<th>').text('PLZ Stadt'));
		$tr.append($('<th>').text('Festnetz'));
		$tr.append($('<th>').text('Mobil'));
	}
	if (usertype == 'sp') {
		$tr.append($('<th>').text('Name'));
		$tr.append($('<th>').text('Skype-Id'));
		$tr.append($('<th>').text('Status'));
		$tr.append($('<th>').text('Postadresse'));
		$tr.append($('<th>').text('PLZ Stadt'));
		$tr.append($('<th>').text('Festnetz'));
		$tr.append($('<th>').text('Mobil'));
		$tr.append($('<th>').text('Sprachen'));
		$tr.append($('<th>').text('Fachbereiche'));
		$tr.append($('<th>').text('Branchen'));
		$tr.append($('<th>').text('Werbercode'));
		$tr.append($('<th>').text('Tonaufn.'));
		$tr.append($('<th>').text('Bankverbindung'));
		$tr.append($('<th>').text('Zuletzt online'));
	}
	$table.append($tr);

	for (var i in users) {
		var user = users[i];
		var $tr = $('<tr>');

		if (!result.limitreached)
			$tr.append(
				$('<td>')
					.append($('<input>').attr('type', 'checkbox'))
					.addClass('select'),
			);

		$tr.append($('<td>').text(user.internalId));

		if (usertype == 'sp') {
			$tr.append(
				$('<td>')
					.addClass('id')
					.append(
						$('<A>')
							.attr({
								target: '_blank',
								href: 'https://manage.yoummday.com/talent/' + user.id,
							})
							.text(user.id),
					),
			);
		} else {
			$tr.append($('<td>').addClass('id').text(user.id));
		}

		if (result.geoaddr) {
			var dist = user.distance * 1;
			if (dist >= 1000) dist = dist.toFixed(0);
			else if (dist >= 100) dist = dist.toFixed(1);
			else if (dist >= 10) dist = dist.toFixed(2);
			else dist = dist.toFixed(3);
			$tr.append($('<td>').text(dist.replace(/\./, ',') + ' km'));
		}

		if (user.imgSmall) {
			var $img = $('<IMG>').attr({ src: user.imgSmall, width: 50, heigth: 50 });
			var $a = $('<A>')
				.attr({ href: user.imgLarge, target: '_blank' })
				.append($img);
			$tr.append($('<td>').append($a));
		} else {
			$tr.append($('<td>').text('-'));
		}
		$tr.append($('<td>').text(user.createTS));
		$tr.append($('<td>').text(user.email));
		$tr.append($('<td>').text(user.emailverified ? 'ja' : ''));
		$tr.append($('<td>').text(user.ymdmail).addClass('small'));
		$tr.append($('<td>').text(user.country));
		$tr.append(
			$('<td>')
				.text(user.ipCountries)
				.css(
					'color',
					user.country == user.ipCountries.substr(0, 2) ? '' : 'red',
				),
		);

		var addressV = null;
		var addressP = null;
		for (var a in user.addresses) {
			if (user.addresses[a].accepts.includes('billing'))
				addressV = user.addresses[a];
			if (user.addresses[a].types.includes('billing'))
				addressP = user.addresses[a];
		}

		if (usertype == 'cu' && user.type == usertype) {
			$tr.append($('<td>').text(user.company));
			$tr.append($('<td>').text(user.contactName));
			$tr.append($('<td>').text(user.verwendungszweck));
			if (addressV) {
				$tr.append(
					$('<td>')
						.text(addressV.line1 + '\n' + addressV.line2)
						.addClass('small'),
				);
				$tr.append($('<td>').text(addressV.zip + ' ' + addressV.city));
			} else if (addressP) {
				$tr.append(
					$('<td>')
						.text(addressP.line1 + '\n' + addressP.line2)
						.addClass('small')
						.css('color', '#f00'),
				);
				$tr.append(
					$('<td>')
						.text(addressP.zip + ' ' + addressP.city)
						.css('color', '#f00'),
				);
			} else {
				$tr.append($('<td>'));
				$tr.append($('<td>'));
			}
			$tr.append(
				$('<td>').text(user.phoneLandline ? '+' + user.phoneLandline : ''),
			);
			$tr.append(
				$('<td>').text(user.phoneMobile ? '+' + user.phoneMobile : ''),
			);
		}
		if (usertype == 'sp' && user.type == usertype) {
			$tr.append($('<td>').text(user.name));
			$tr.append($('<td>').text(user.skypeId));
			var $status = $('<span>').addClass('circle');
			var statusText = user.status;
			if (user.status == 'offline') {
				$status.css('background-color', '#f00');
			}
			if (user.status == 'paused') {
				$status.css('background-color', '#fd0');
				statusText = 'pausiert';
			}
			if (user.status == 'online') {
				$status.css('background-color', '#0f0');
			}
			$tr.append(
				$('<td>')
					.append($status)
					.append(' ' + statusText)
					.addClass('small'),
			);
			if (addressV) {
				$tr.append(
					$('<td>')
						.text(addressV.line1 + '\n' + addressV.line2)
						.addClass('small'),
				);
				$tr.append($('<td>').text(addressV.zip + ' ' + addressV.city));
			} else if (addressP) {
				$tr.append(
					$('<td>')
						.text(addressP.line1 + '\n' + addressP.line2)
						.addClass('small')
						.css('color', '#f00'),
				);
				$tr.append(
					$('<td>')
						.text(addressP.zip + ' ' + addressP.city)
						.css('color', '#f00'),
				);
			} else {
				$tr.append($('<td>'));
				$tr.append($('<td>'));
			}
			$tr.append(
				$('<td>').text(user.phoneLandline ? '+' + user.phoneLandline : ''),
			);
			$tr.append(
				$('<td>').text(user.phoneMobile ? '+' + user.phoneMobile : ''),
			);
			$tr.append($('<td>').text(user.spokenLangs.join(' ')));
			$tr.append($('<td>').text(user.expBusinesses.join(' ')));
			$tr.append($('<td>').text(user.referalcode));
			var vs = user.voicesamples ? user.voicesamples.length : 0;
			$tr.append($('<td>').text(vs ? vs : '-'));
			$tr.append(
				$('<td>')
					.text(
						(user.iban ? 'IBAN:' + user.iban : '') +
							' ' +
							(user.bankAccNum ? 'Account:' + user.bankAccNum : '') +
							' ' +
							(user.bankBranchId ? 'Branch:' + user.bankBranchId : '') +
							' ' +
							(user.swift ? 'Swift:' + user.swift : ''),
					)
					.addClass('small'),
			);
			$tr.append($('<td>').text(user.lastonline));
		}
		if (usertype == 'cu' && user.type == usertype) {
			$tr
				.addClass('clickable')
				.data('user', {
					id: user.id,
					name: user.company ? user.company : user.contactName,
				})
				.click(function () {
					var user = $(this).data('user');
					$('#selectedUser').show();
					$('#selectedUserId').text(user.id);
					$('#selectedUserName').text(user.name);
				});
		}
		$table.append($tr);
	}
	let $extraButton;
	if (!result.limitreached) {
		$extraButton = $('<BUTTON>').text('ausgew\u00E4hlte Ids kopieren');
		$extraButton.click(function () {
			var txt = '';
			$('TABLE TR').each(function (i, e) {
				var a = $(e).find('td.select input:checked').length;
				var b = $(e).find('td.id').text();
				if (a && b) txt = txt + b + ' ';
			});
			if (txt) {
				var $t = $('<SPAN>').text(txt);
				$('BODY').append($t);
				var range = document.createRange();
				range.selectNodeContents($t[0]);
				window.getSelection().removeAllRanges();
				window.getSelection().addRange(range);
				var r = document.execCommand('copy');
				$t.remove();
				alert('In Zwischenablage ' + (r ? '' : 'NICHT ') + 'kopiert.');
			} else {
				alert('Keine Nutzer ausgew\u00E4hlt.');
			}
		});
	}

	var config = $('#choose button.selected').data('config');
	$('#result').append($table);
	if (!config.noexport && $table.find('TR').length > 3) {
		var $a = $('<button>').text('Exportieren').click(exportToExcel);
		$('#result').append($a);
	}

	if ($extraButton) $('#result').append($extraButton);

	$('#result').show();
	return $extraButton;
}

function showSoundList(data, result) {
	$('#optfile').val('');
	$('#optname').val('');
	$('#result *').remove();
	let snds = result.soundlist;
	let table = $('<table>');
	let tr = $('<tr>');
	tr.append($('<th>').text('ID'));
	tr.append($('<th>').text('Name'));
	tr.append($('<th>').text('Kategorie'));
	tr.append($('<th>').text('Upload Datum (UTC)'));
	tr.append($('<th>').text('Verfügbar auf Telserver'));
	tr.append($('<th>').text('Anhören'));
	tr.append($('<th>').text(' '));
	table.append(tr);

	for (let i in snds) {
		let snd = snds[i];
		let tr = $('<tr>');
		tr.append($('<td>').text(snd.id));
		tr.append($('<td>').text(snd.filename));
		tr.append($('<td>').text(snd.type));
		tr.append($('<td>').text(snd.uploadTS));
		tr.append($('<td>').text(snd.isavailable));

		if (snd.filepath != '') {
			let audio = $('<audio>');
			audio.attr('src', snd.filepath);
			// audio.attr("type", "audio/wav");
			audio.attr('controls', 'controls');
			tr.append($('<td>').append(audio));
		} else {
			tr.append($('<td>').text('Manueller Upload'));
		}

		let del = $('<button>').text('Löschen?');
		del.data('sndid', snd.id).click((event) => {
			let soundid = $(event.currentTarget).data('sndid');
			if (confirm('Sicher ?')) {
				api('deletesound', { soundid: soundid, companyuser: data.companyuser });
			}
		});

		tr.append($('<td>').append(del));
		table.append(tr);
	}

	$('#result').append(table);
	$('#result').show();
}

function showNumberRouting(result) {
	$('#result *').remove();

	let numbers = result.numbers;
	let table = $('<table>');
	let tr = $('<tr>');
	tr.append($('<th>').text('Nummer'));
	tr.append($('<th>').text('Musik'));
	tr.append($('<th>').text('Vor Warteschlange'));
	tr.append($('<th>').text('Out of Office Ansage'));
	tr.append($('<th>').text('Abfrage nach Aufnahme'));
	tr.append($('<th>').text('Rückrufanfrage'));
	tr.append($('<th>').text('Anruferlimit erreicht'));
	tr.append($('<th>').text('Maximaldauer erreicht'));
	tr.append($('<th>').text('Fifo Chime'));

	table.append(tr);

	for (let i in numbers) {
		let number = numbers[i];
		let tr = $('<tr>');

		if (number.routing == 'single') {
			tr.append($('<td>').text(number.phone).css('color', 'lightgrey'));
			tr.append($('<td>').text('Kein Fifo'));
			tr.append($('<td>').text(''));
			tr.append($('<td>').text(''));
			tr.append($('<td>').text(''));
			tr.append($('<td>').text(''));
			tr.append($('<td>').text(''));
			tr.append($('<td>').text(''));
			tr.append($('<td>').text(''));
		} else {
			// yes this still uses the old names
			tr.append($('<td>').text(number.phone));
			tr.append($('<td>').text(number.routing.fifo_music));
			tr.append($('<td>').text(number.routing.pre_fifo_sound));
			tr.append($('<td>').text(number.routing.oob_sound));
			tr.append($('<td>').text(number.routing.askRecord_sound));
			tr.append($('<td>').text(number.routing.callback_sound));
			tr.append($('<td>').text(number.routing.caller_limit_sound));
			tr.append($('<td>').text(number.routing.maxTime_sound));
			tr.append($('<td>').text(number.routing.fifo_chime_sound));
		}

		table.append(tr);
	}

	$('#result').append(table);
	$('#result').show();
}

function showTelHealth(result) {
	$('#result *').remove();

	let hosts = result.hosts;
	let table = $('<table>');
	let tr = $('<tr>');
	tr.append($('<th>').text('Hostname'));
	tr.append($('<th>').text('Letzter Restart'));
	tr.append($('<th>').text('Letzter Keepalive'));

	table.append(tr);

	for (let hostname in hosts) {
		let host = hosts[hostname];
		let tr = $('<tr>');

		tr.append($('<td>').text(hostname));
		tr.append($('<td>').text(host.lastRestart));
		tr.append($('<td>').text(host.lastKeepAlive));

		table.append(tr);
	}

	$('#result').append(table);
	$('#result').show();
}

function showAiQaConfigs(result) {
	$('#result *').remove();

	let criterias = result.criterias;
	let table = $('<table>');
	let tr = $('<tr>');
	tr.append($('<th>').text('Id'));
	tr.append($('<th>').text('Label'));
	tr.append($('<th>').text('Form Type'));
	tr.append($('<th>').text('Model Type'));
	tr.append($('<th>').text('Details'));

	table.append(tr);

	for (let i in criterias) {
		const criteria = criterias[i];
		let tr = $('<tr>');

		tr.append($('<td>').text(criteria.id).css('color', 'lightgrey'));
		tr.append($('<td>').text(criteria.label));
		tr.append($('<td>').text(criteria.type));
		tr.append($('<td>').text(criteria.model_type));
		tr.append($('<td>').text(criteria.details));

		table.append(tr);
	}

	$('#result').append(table);
	$('#result').show();
}

function showAiQaCriteria(result) {
	$('#result *').remove();

	const criteria = result.criteria;
	let table = $('<table>');
	let tr = $('<tr>');
	tr.append($('<th>').text('Id'));
	tr.append($('<th>').text('Label'));
	tr.append($('<th>').text('Form Type'));
	tr.append($('<th>').text('Model Type'));
	tr.append($('<th>').text('Details'));

	table.append(tr);

	tr = $('<tr>');

	tr.append($('<td>').text(criteria.id).css('color', 'lightgrey'));
	tr.append($('<td>').text(criteria.label));
	tr.append($('<td>').text(criteria.type));
	tr.append($('<td>').text(criteria.model_type));
	tr.append($('<td>').text(criteria.details));

	table.append(tr);

	$('#result').append(table);
	$('#result').show();
}

function showVerifiedNumberList(result) {
	$('#result *').remove();

	const numbers = result.list;
	let table = $('<table>');
	let tr = $('<tr>');
	tr.append($('<th>').text('Id'));
	tr.append($('<th>').text('Number'));
	tr.append($('<th>').text('verifyTS'));

	table.append(tr);

	for (let i in numbers) {
		const number = numbers[i];
		let tr = $('<tr>');

		tr.append($('<td>').text(number.id));
		tr.append($('<td>').text(number.number));
		tr.append($('<td>').text(number.verifyTS));

		table.append(tr);
	}

	$('#result').append(table);
	$('#result').show();
}

function showResult(cmd, data, result, ref) {
	if (cmd === 'forceholdpayment') {
		alert('Success: ' + result.success);
		return;
	}

	if (cmd == 'dummy') {
		if (location.hash != '') {
			document.getElementById(location.hash.substr(1)).click();
		}
		$('#choose').show();
		return;
	}
	if (cmd === 'uploadsound' || cmd === 'soundlist' || cmd === 'deletesound') {
		showSoundList(data, result);
	}

	if (cmd == 'setsoundnumber') {
		api('getroutings', {
			companyuser: data.companyuser,
		});
	}

	if (cmd == 'getroutings') {
		showNumberRouting(result);
	}

	if (cmd == 'telhealth') {
		showTelHealth(result);
	}

	if (cmd == 'listuser') {
		showListUser(data, result);
	}

	if (cmd == 'agentminutes') {
		showAgentminutes(result);
	}

	if (cmd == 'agentcalls') {
		showAgentcalls(result);
	}

	if (cmd == 'contracts') {
		showContracts(result);
	}

	if (cmd == 'inboundcallstats') {
		showInboundcallstats(result, ref);
	}

	if (cmd == 'fifo') {
		showFifo(result);
	}

	if (cmd == 'modules') {
		showModules(result);
	}

	if (cmd == 'futurepayments') {
		showFuturepayments(result);
	}

	if (cmd == 'dispo') {
		showDispo(result);
	}

	if (cmd == 'utilization') {
		showUtilization(result);
	}

	if (cmd === 'blockuser') {
		alert('Die Aktion wurde erfolgreich ausgeführt.');
	}

	if (cmd == 'invoice') {
		showInvoice(result);
	}

	if (cmd == 'extrafee') {
		showExtrafee(result);
	}

	if (cmd == 'payoutdata') {
		showPayoutdata(result);
	}

	if (cmd == 'silentmonitor') {
		showSilentmonitor(result);
	}

	if (cmd == 'dashboard') {
		showDashboard(result);
	}

	if (cmd == 'evn') {
		showEvn(result);
	}

	if (cmd == 'admdocument') {
		showDocument(result);
	}

	if (cmd == 'dailysurvey') {
		showDailysurvey(result);
	}

	if (cmd == 'siplog') {
		showSiplog(result);
	}

	if (cmd == 'concentrix') {
		showConcentrix(result);
	}

	if (cmd === 'handleroamingusers') {
		showHandleroamingusers(result);
	}

	if (cmd === 'referalprovision') {
		showReferalprovision(result);
	}

	if (cmd === 'accesstoreport') {
		showAccessToReport(result);
	}

	if (cmd === 'hbciassign') {
		showHBCI(result);
	}

	if (cmd === 'onboardingfeatures') {
		showOnboardingfeatures(result);
	}

	if (cmd === 'talentbookings') {
		showTalentbookings(result);
	}

	// TODO:
	if (cmd === 'upsertaiqaconfig') {
		showAiQaConfigs(result);
	}

	if (cmd === 'upsertaiqacriteria') {
		showAiQaCriteria(result);
	}

	if (
		cmd === 'verifynumber' ||
		cmd === 'verifiednumberlist' ||
		cmd === 'verifiednumberdelete'
	) {
		showVerifiedNumberList(result);
	}
}

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + '; ' + expires;
}

function getCookie(cname) {
	var name = cname + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

function updateBtnClicked() {
	$('#result').hide();
	var c = $('#choose button.selected').data('config');
	var opts = {};
	for (var i in c.options) {
		var o = c.options[i];
		if (o.type == 'checkbox') {
			opts[o.name] = $('#opt' + o.name).is(':checked') ? 1 : 0;
		}
		if (o.type == 'enum') {
			opts[o.name] = $('input[name=opt' + o.name + ']:checked').val();
		}
		if (o.type === 'text' || o.type === 'textarea') {
			opts[o.name] = $('#opt' + o.name).val();
		}
		if (o.type === 'file') {
			let files = $('#opt' + o.name).prop('files');
			if (files.length > 0) {
				opts[o.name] = files[0];
			} else {
				opts[o.name] = '';
			}
		}
	}
	c.request(opts);

	location.hash = c.title;
}

function chooseBtnClicked() {
	var c = $(this).data('config');

	if (refreshTimer) clearTimeout(refreshTimer);
	refreshTimer = 0;

	$('#choose button').removeClass('selected');
	$(this).addClass('selected');

	$('#result, #option').hide();
	$('#option *').remove();
	var $t = $('<table>');

	let options = c.options;
	// Add checkbox for manage rights
	if (!rightsUpdated && c.code != undefined && c.code == 'manage_rights') {
		possibleRightsApi(function (result) {
			for (var right of result) {
				possibleRights.push(right);
				var title = possibleRightsTranslation[right];
				if (title !== undefined && title !== '') {
					title = title + ' - (' + right + ')';
				} else {
					title = right;
				}
				options.push({
					name: 'rights_' + right,
					type: 'checkbox',
					default: false,
					title: title,
				});
			}
			rightsUpdated = true;
		});
	}

	for (var i in options) {
		var o = options[i];
		var $tr;
		if (o.type == 'checkbox') {
			var $a = $('<input>')
				.attr('type', 'checkbox')
				.attr('id', 'opt' + o.name)
				.prop('checked', o.default);
			var $b = $('<label>')
				.attr('for', 'opt' + o.name)
				.text(o.title);
			$tr = $('<tr>');
			$tr.append($('<td>').append($b));
			$tr.append($('<td>').append($a));
			$t.append($tr);
			if (o.onchange) {
				$a.change(o.onchange);
			}
		}
		if (o.type == 'enum') {
			var def = o.default;
			if (o.name == 'userid' && def == '') def = $('#selectedUserId').text();
			var $a = $('<span>');
			var $b = $('<label>').text(o.title + ': ');
			$tr = $('<tr>');
			var i = 0;
			for (var a in o.values) {
				var $c = $('<input>')
					.attr('type', 'radio')
					.attr('name', 'opt' + o.name)
					.attr('id', 'opt' + o.name + i)
					.val(a)
					.prop('checked', a == o.default);
				var $d = $('<label>')
					.attr('for', 'opt' + o.name + i)
					.text(o.values[a]);
				$a.append($c);
				$a.append($d);
				i++;
			}
			$tr.append($('<td>').append($b));
			$tr.append($('<td>').append($a));
			$t.append($tr);
		}
		if (o.type == 'text') {
			var def = o.default;
			if (o.name == 'userid' && def == '') def = $('#selectedUserId').text();
			var $a = $('<input>')
				.attr('type', 'text')
				.attr('id', 'opt' + o.name)
				.val(def);
			if (typeof o.placeholder !== 'undefined') {
				$a.attr('placeholder', o.placeholder);
			}
			if (typeof o.style !== 'undefined') {
				$a.attr('style', o.style);
			}
			var $b = $('<label>')
				.attr('for', 'opt' + o.name)
				.text(o.title + ': ');
			$tr = $('<tr>');
			$tr.append($('<td>').append($b));
			$tr.append($('<td>').append($a));
			$t.append($tr);
		}
		if (o.type == 'textarea') {
			var def = o.default;
			var $a = $('<textarea>')
				.attr('style', 'min-width:600px;min-height:200px')
				.attr('id', 'opt' + o.name)
				.val(def)
				.on('keyup', function () {
					this.style.height = 'auto';
					this.style.height = this.scrollHeight + 'px';
				});
			var $b = $('<label>')
				.attr('for', 'opt' + o.name)
				.text(o.title + ': ');
			$tr = $('<tr>');
			$tr.append($('<td>').append($b));
			$tr.append($('<td>').append($a));
			$t.append($tr);
		}
		if (o.type == 'comment') {
			var $a = $('<span>').text(o.text);
			if (o.color) $a.css('color', o.color);
			$tr = $('<tr>');
			$tr.append($('<td>').attr('colspan', 2).append($a));
			$t.append($tr);
		}
		if (o.type == 'file') {
			var $a = $('<input>')
				.attr('type', 'file')
				.attr('id', 'opt' + o.name);
			if (typeof o.placeholder !== 'undefined') {
				$a.attr('placeholder', o.placeholder);
			}
			if (typeof o.style !== 'undefined') {
				$a.attr('style', o.style);
			}
			if (typeof o.valuetypes !== 'undefined') {
				$a.attr('accept', o.valuetypes);
			}

			var $b = $('<label>')
				.attr('for', 'opt' + o.name)
				.text(o.title + ': ');
			$tr = $('<tr>');
			$tr.append($('<td>').append($b));
			$tr.append($('<td>').append($a));
			$t.append($tr);
		}
	}
	$('#option').append($t);
	if (c.options.length) {
		var $a = $('<button>')
			.text(c.btnTitle ? c.btnTitle : 'Aktualisieren')
			.click(updateBtnClicked);
		$('#option').append($a).show();
	}
	updateBtnClicked();
}

function init() {
	api('dummy');
}

function possibleRightsApi(callback) {
	$.ajax({
		url: getRequestUrl('possiblerights'),
		type: 'POST',
		cache: false,
		contentType: false,
		processData: false,
		async: false,
		dataType: 'json',
		success: function (result) {
			if (result.error) {
				if (result.error == 'auth') {
					alert('auth');
				} else {
					alert(result.error);
				}
			} else if (!result.success) {
				alert('fail');
			} else {
				callback(result.possibleRights);
			}
		},
	});
}

function getInvoiceDownloadFor(btnText, bookId, type) {
	return $('<button>')
		.text(btnText)
		.click(function () {
			var form = $('<FORM>')
				.attr('method', 'POST')
				.attr('action', getRequestUrl('downloadinvoices'));
			form.append(
				$('<INPUT>')
					.attr('type', 'hidden')
					.attr('name', 'bookId')
					.attr('value', bookId),
			);
			if (type) {
				form.append(
					$('<INPUT>')
						.attr('type', 'hidden')
						.attr('name', 'type')
						.attr('value', type),
				);
			}
			form.append($('<INPUT>').attr('type', 'submit'));
			$('BODY').append(form);
			form.submit();
			form.remove();
		});
}

$(function () {
	token = getCookie('admintooltoken');
	while (!token || token.length < 15)
		token += Math.random().toString(36).substr(2, 5);
	token = token.substr(0, 15);
	setCookie('admintooltoken', token, 1 / 12);
	$('#btnLogout').click(function () {
		logout();
	});

	$('#selectedUserClose').click(function () {
		$('#selectedUser').hide();
		$('#selectedUserId').text('');
		$('#selectedUserName').text('');
	});

	for (var i in config) {
		let c = config[i];
		if (c.options || c.request) {
			var $b = $('<button>').text(c.title).data('config', c);
			$b.attr('id', encodeURI(c.title));
			if (c.deprecated) $b.addClass('deprecated');
			$b.click(chooseBtnClicked);
			$('#choose').append($b);
		} else {
			var $t = $('<span>').text(c.title);
			$('#choose').append($('<br>')).append($t);
		}
	}
	init();
});
